"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9972],{

/***/ 8887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




var CustomTooltip = function(param) {
    var customStyle = param.customStyle, content = param.content, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showTooltip = ref[0], setShowTooltip = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        top: 0,
        left: 0
    }), tooltipPosition = ref1[0], setTooltipPosition = ref1[1];
    var tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleMouseEnter = function() {
        setShowTooltip(true);
    };
    var handleMouseLeave = function() {
        setShowTooltip(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (showTooltip && tooltipRef.current && containerRef.current) {
            var tooltipRect = tooltipRef.current.getBoundingClientRect();
            var containerRect = containerRef.current.getBoundingClientRect();
            var viewportWidth = window.innerWidth;
            var viewportHeight = window.innerHeight;
            var top, left;
            // Check if there's room below
            if (containerRect.bottom + tooltipRect.height <= viewportHeight) {
                top = containerRect.bottom;
            } else if (containerRect.top - tooltipRect.height >= 0) {
                top = containerRect.top - tooltipRect.height;
            } else {
                top = Math.max(0, (containerRect.top + containerRect.bottom) / 2 - tooltipRect.height / 2);
            }
            // Check if there's room to the right
            if (containerRect.right + tooltipRect.width <= viewportWidth) {
                left = containerRect.right;
            } else if (containerRect.left - tooltipRect.width >= 0) {
                left = containerRect.left - tooltipRect.width;
            } else {
                left = Math.max(0, (containerRect.left + containerRect.right) / 2 - tooltipRect.width / 2);
            }
            setTooltipPosition({
                top: top,
                left: left
            });
        }
    }, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "custom-tooltip",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ref: containerRef,
        children: [
            children,
            showTooltip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: tooltipRef,
                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, customStyle), {
                    position: "fixed",
                    top: "".concat(tooltipPosition.top, "px"),
                    left: "".concat(tooltipPosition.left, "px"),
                    maxWidth: "300px",
                    zIndex: 9999
                }),
                className: "tooltip-content",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tooltip-content-inner",
                    children: content
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomTooltip);


/***/ }),

/***/ 47018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Bank = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-bank",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.501.501 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89L8 0ZM3.777 3h8.447L8 1 3.777 3ZM2 6v7h1V6H2Zm2 0v7h2.5V6H4Zm3.5 0v7h1V6h-1Zm2 0v7H12V6H9.5ZM13 6v7h1V6h-1Zm2-1V4H1v1h14Zm-.39 9H1.39l-.25 1h13.72l-.25-1Z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Bank);


/***/ }),

/***/ 15926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ Calendar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Calendar = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-calendar",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
        })
    });
};


/***/ }),

/***/ 20832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CashCoin = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-cash-coin",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                "fill-rule": "evenodd",
                d: "M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CashCoin);


/***/ }),

/***/ 12426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Cash; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Cash = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-cash",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"
            })
        ]
    });
};


/***/ }),

/***/ 73760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Clock = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        class: "bi bi-clock",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Clock);


/***/ }),

/***/ 56884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var DatabaseUp = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        class: "bi bi-database-up",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.096 6.223A5 5 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.5 4.5 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-.813-.927Q8.378 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.6 4.6 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10q.393 0 .774-.024a4.5 4.5 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777M3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DatabaseUp);


/***/ }),

/***/ 28221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Dollar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Dollar = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-currency-dollar",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"
        })
    });
};


/***/ }),

/***/ 69932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ FileDiff; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FileDiff = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-file-diff",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 4a.5.5 0 0 1 .5.5V6H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V7H6a.5.5 0 0 1 0-1h1.5V4.5A.5.5 0 0 1 8 4zm-2.5 6.5A.5.5 0 0 1 6 10h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"
            })
        ]
    });
};


/***/ }),

/***/ 24925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ GraphUp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var GraphUp = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-graph-up",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            "fill-rule": "evenodd",
            d: "M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z"
        })
    });
};


/***/ }),

/***/ 75256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InfoCircle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var InfoCircle = function(param) {
    var fill = param.fill, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        style: style,
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-text)",
        class: "bi bi-info-circle",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            })
        ]
    });
};


/***/ }),

/***/ 93160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Percent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Percent = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-percent",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
        })
    });
};


/***/ }),

/***/ 28113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PlusSlashMinus; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PlusSlashMinus = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-plus-slash-minus",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "m1.854 14.854 13-13a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708ZM4 1a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 4 1Zm5 11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 9 12Z"
        })
    });
};


/***/ }),

/***/ 73549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ Wallet; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var Wallet = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-wallet2",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"
        })
    });
};


/***/ }),

/***/ 89972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wy": function() { return /* binding */ CustomYAxisTick; },
  "hJ": function() { return /* binding */ IsMobileDevice; },
  "Ym": function() { return /* binding */ ONE_DAY_IN_SECONDS; },
  "iv": function() { return /* binding */ TokenType; },
  "z5": function() { return /* binding */ appendPlusOrMinus; },
  "HH": function() { return /* binding */ assemblePositionName; },
  "TH": function() { return /* binding */ assembleStatusMessageDetailsPage; },
  "QN": function() { return /* binding */ buildKeyToIdentifierMap; },
  "pD": function() { return /* binding */ calculateCostBasis; },
  "zC": function() { return /* binding */ calculateExitValue; },
  "mq": function() { return /* binding */ calculateExitedCollectedIncomeUsd; },
  "zR": function() { return /* binding */ calculateMarketGains; },
  "CZ": function() { return /* binding */ calculateMarketGainsPct; },
  "Lk": function() { return /* binding */ calculatePendingIncomeUsd; },
  "xx": function() { return /* binding */ calculatePercentageDifference; },
  "K3": function() { return /* binding */ calculateRoiVsHodl; },
  "qT": function() { return /* binding */ calculateRoiVsHodlPct; },
  "O": function() { return /* binding */ calculateTimeDifference; },
  "Eu": function() { return /* binding */ checkTokenAndType; },
  "$I": function() { return /* binding */ columnDataCurrentLB; },
  "G7": function() { return /* binding */ columnDataCurrentNonLB; },
  "ty": function() { return /* binding */ columnDataExitedLB; },
  "nD": function() { return /* binding */ columnDataExitedNonLB; },
  "z$": function() { return /* binding */ columnTokens; },
  "BV": function() { return /* binding */ columnTokensExited; },
  "xo": function() { return /* binding */ createResult; },
  "uc": function() { return /* binding */ cryptoGetRandomKey; },
  "zK": function() { return /* binding */ displayPrettyNumber; },
  "$p": function() { return /* binding */ extractKeysWithCapitalLetters; },
  "Yv": function() { return /* binding */ fetchProtocolsAndSet; },
  "Ni": function() { return /* binding */ filterAndRemoveDuplicates; },
  "Kt": function() { return /* binding */ fontSize16AndFontWeight600; },
  "Tg": function() { return /* binding */ formatAddress; },
  "o4": function() { return /* binding */ formatEntry; },
  "ZP": function() { return /* binding */ formatUSD; },
  "Hx": function() { return /* binding */ getAmountWithdrawnOrDepositedChange; },
  "YO": function() { return /* binding */ getAmountWithdrawnOrDepositedChangeNumberOnly; },
  "$y": function() { return /* binding */ getBeaconChainScanLink; },
  "C0": function() { return /* binding */ getBlockchainScanLink; },
  "jA": function() { return /* binding */ getBorrowedOrSuppliedPositionInfo; },
  "cQ": function() { return /* binding */ getButtonBasedOnTitle; },
  "xn": function() { return /* binding */ getChain; },
  "LQ": function() { return /* binding */ getChainId; },
  "dH": function() { return /* binding */ getChainLogo; },
  "NO": function() { return /* binding */ getColumnIcon; },
  "L1": function() { return /* binding */ getColumnValue; },
  "h_": function() { return /* binding */ getColumnValueExited; },
  "Ah": function() { return /* binding */ getImageForProtocol; },
  "I2": function() { return /* binding */ getKeysToQuery; },
  "EI": function() { return /* binding */ getNonReceiptTokensByDate; },
  "WN": function() { return /* binding */ getProtocolManifestValue; },
  "SU": function() { return /* binding */ handleApiRequest; },
  "lq": function() { return /* binding */ headerDescriptionsForOperationTokens; },
  "$w": function() { return /* binding */ headersDescriptionsForActivePositions; },
  "Uc": function() { return /* binding */ headersDescriptionsForActiveTokens; },
  "GM": function() { return /* binding */ headersDescriptionsForExitedPositions; },
  "kl": function() { return /* binding */ headersDescriptionsForTransactions; },
  "Uz": function() { return /* binding */ incomeColumns; },
  "_m": function() { return /* binding */ incomeColumnsExited; },
  "qS": function() { return /* binding */ isLBProtocolWithMultipleUnderlyingTokens; },
  "ld": function() { return /* binding */ isLiabilityPosition; },
  "T5": function() { return /* binding */ isProtocolLB; },
  "z_": function() { return /* binding */ isVaultsProtocol; },
  "ag": function() { return /* binding */ mapEntryToTableRow; },
  "BX": function() { return /* binding */ mapOperationType; },
  "Qs": function() { return /* binding */ modifyAndFindMatchingPositionData; },
  "fh": function() { return /* binding */ modifyAndFindMatchingPositionDataLB; },
  "sv": function() { return /* binding */ needsResync; },
  "C5": function() { return /* binding */ prettifyProtocolKey; },
  "R4": function() { return /* binding */ renderColumnTokens; },
  "QH": function() { return /* binding */ renderColumnTokensExited; },
  "rb": function() { return /* binding */ renderTooltip; },
  "cy": function() { return /* binding */ shouldReturnNegatedValues; },
  "A_": function() { return /* binding */ simplifiedReconfigureEntries; },
  "hp": function() { return /* binding */ standardChartTitleStyle; },
  "xe": function() { return /* binding */ transformDataForCsv; },
  "Wp": function() { return /* binding */ walletAddressCheck; },
  "yo": function() { return /* binding */ yieldColumns; }
});

// UNUSED EXPORTS: addUserAdddressToUrl, assembleStatusMessage, calculateCollectedIncomeUsd, checkDataValidity, checkRegularWallet, config, decodeENS, extractValidatorIndex, filterEntriesByDate, findAndSetProtocolObject, findEntryByDate, findLatestWithdrawalOrTransferOut, findMatchingEntriesWithWithdrawal, findMostRecentSession, findProtocolByKey, flattenData, getChainBlockTime, getColumnIconExited, getParticularIncomeData, getUniqueIncomeTokens, hodlColumns, incomeTokenColumns, incomeTokenColumnsExited, isBlueprintNonEVM, maybeRenderTokenAmountsAndPrices, populateConifg, prettifyAndReduceIncomeData, processIntervalData, reconfigureEntries, renderOgImage, shouldUseAuthToken, splitSessions, toDecimalPlaceDigits, transformData, useWindowSize

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/TokenLogo/index.jsx







var BAD_IMAGES = {};
function TokenLogo(_param) {
    var chainId = _param.chainId, address = _param.address, _header = _param.header, header = _header === void 0 ? false : _header, size = _param.size, tokenImage = _param.tokenImage, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "chainId",
        "address",
        "header",
        "size",
        "tokenImage"
    ]);
    var ref = (0,react.useState)(null), storedTokenImage = ref[0], setTokenImage = ref[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var tokenResp;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return axios/* default.get */.Z.get("".concat("https://qa.contracts.archiveprotocol.com", "/tokenInfo/iconUrl/").concat(chainId, "/").concat(address));
                        case 2:
                            tokenResp = _ctx.sent;
                            setTokenImage(tokenResp.data.result.iconUrl);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            width: size,
            height: size,
            marginRight: 2
        },
        className: "inline styled-img",
        children: storedTokenImage && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            priority: true,
            width: size,
            height: size,
            alt: "",
            src: storedTokenImage,
            onError: function(event) {
                BAD_IMAGES[address] = true;
                event.preventDefault();
            }
        })
    });
};

// EXTERNAL MODULE: ./src/components/manifest/manifest.js
var manifest = __webpack_require__(31170);
// EXTERNAL MODULE: ./src/components/tooltip/CustomTooltip.jsx
var tooltip_CustomTooltip = __webpack_require__(8887);
// EXTERNAL MODULE: ./src/lib/amplitude.js
var amplitude = __webpack_require__(52131);
// EXTERNAL MODULE: ./src/svg/bank.js
var bank = __webpack_require__(47018);
// EXTERNAL MODULE: ./src/svg/calendar.js
var calendar = __webpack_require__(15926);
// EXTERNAL MODULE: ./src/svg/cash.js
var cash = __webpack_require__(12426);
// EXTERNAL MODULE: ./src/svg/cash-coin.js
var cash_coin = __webpack_require__(20832);
// EXTERNAL MODULE: ./src/svg/clock.js
var clock = __webpack_require__(73760);
// EXTERNAL MODULE: ./src/svg/database-up.js
var database_up = __webpack_require__(56884);
// EXTERNAL MODULE: ./src/svg/dollar.js
var dollar = __webpack_require__(28221);
// EXTERNAL MODULE: ./src/svg/file-diff.js
var file_diff = __webpack_require__(69932);
;// CONCATENATED MODULE: ./src/svg/flag.js


var Flag = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-flag",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z"
        })
    });
};
/* harmony default export */ var flag = (Flag);

// EXTERNAL MODULE: ./src/svg/graph-up.js
var graph_up = __webpack_require__(24925);
// EXTERNAL MODULE: ./src/svg/info-circle.js
var info_circle = __webpack_require__(75256);
// EXTERNAL MODULE: ./src/svg/percent.js
var percent = __webpack_require__(93160);
;// CONCATENATED MODULE: ./src/svg/pin-fill.js


var pin_fill_PinFill = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--color-primary)",
        className: "bi bi-pin-fill",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A5.921 5.921 0 0 1 5 6.708V2.277a2.77 2.77 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354z"
        })
    });
};

// EXTERNAL MODULE: ./src/svg/plus-slash-minus.js
var plus_slash_minus = __webpack_require__(28113);
// EXTERNAL MODULE: ./src/svg/wallet-2.js
var wallet_2 = __webpack_require__(73549);
// EXTERNAL MODULE: ./src/utils/constants.js
var constants = __webpack_require__(47426);
// EXTERNAL MODULE: ./src/utils/localstorage.js
var localstorage = __webpack_require__(30677);
// EXTERNAL MODULE: ./node_modules/chain-config/dist/index.js
var dist = __webpack_require__(78269);
// EXTERNAL MODULE: ./node_modules/graphql/language/printer.mjs + 2 modules
var printer = __webpack_require__(62938);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
;// CONCATENATED MODULE: ./src/utils/utils.jsx




































var config = {
    headers: {
        "api-key": "3823f786-4f16-47d2-abcc-61d1ccf63fa9"
    }
};
var populateConifg = {
    headers: {
        "populate-day-data-key": "3823f786-4f16-47d2-abcc-61d1ccf63fa9"
    }
};
var checkRegularWallet = function(walletAddress) {
    if (!walletAddress.startsWith("0x")) return false;
    return walletAddress.length === 42 && !hasWhiteSpace(walletAddress) && !containsSpecialChars(walletAddress);
};
var checkDotEthWallet = function(walletAddress) {
    if (!walletAddress.endsWith(".eth")) return false;
    return !hasWhiteSpace(walletAddress) && !containsSpecialCharsExceptDot(walletAddress);
};
var checkEvmosWallet = function(walletAddress) {
    var walletAddressRegex = /^(evmos1[a-z0-9]{38})$/i;
    var isValid = walletAddressRegex.test(walletAddress) && !hasWhiteSpace(walletAddress) && !containsSpecialChars(walletAddress);
    return isValid;
};
var checkSolanaWallet = function(walletAddress) {
    var walletAddressRegex = /^[1-9A-HJ-NP-Za-km-z]+$/;
    var isValid = walletAddressRegex.test(walletAddress);
    return walletAddress.length >= 32 && walletAddress.length <= 44 && isValid;
};
var checkCosmosWallet = function(walletAddress) {
    var walletAddressRegex = /^(osmo1[a-z0-9]{38}|cosmos1[a-z0-9]{38})$/i;
    var isValid = walletAddressRegex.test(walletAddress) && !hasWhiteSpace(walletAddress) && !containsSpecialChars(walletAddress);
    return isValid;
};
var checkAvalancheWallet = function(walletAddress) {
    var walletAddressRegex = /^avax1[a-hj-np-z0-9]+$/;
    var isValid = walletAddressRegex.test(walletAddress) && !hasWhiteSpace(walletAddress) && !containsSpecialChars(walletAddress);
    return isValid;
};
var walletAddressCheck = function(walletAddress) {
    var protocolChecks = {
        evmos: checkEvmosWallet,
        solana: checkSolanaWallet,
        avalanche: checkAvalancheWallet,
        cosmos: checkCosmosWallet,
        regular: checkRegularDotEthFallback
    };
    // const quickCheckRegex = /^[a-zA-Z0-9]{26,}$/;
    // if (!quickCheckRegex.test(walletAddress)) {
    //   return false;
    // }
    var results = Object.entries(protocolChecks).reduce(function(acc, param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], checkFunction = _param[1];
        try {
            acc[key] = checkFunction(walletAddress);
        } catch (error) {
            acc[key] = false;
            console.error("Error in ".concat(key, " check:"), error);
        }
        return acc;
    }, {});
    var isValid = Object.values(results).some(function(result) {
        return result === true;
    });
    return isValid;
};
var checkRegularDotEthFallback = function(walletAddress) {
    return checkRegularWallet(walletAddress) || checkDotEthWallet(walletAddress);
};
function hasWhiteSpace(s) {
    return /\s/g.test(s);
}
function containsSpecialChars(str) {
    var specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    return specialChars.test(str);
}
function containsSpecialCharsExceptDot(str) {
    var specialChars = /[`!@#$%^&*()_+\-=\[\]{};'"\\|,<>\/?~]/;
    return specialChars.test(str);
}
function decodeENS(ensDomain) {
    return _decodeENS.apply(this, arguments);
}
function _decodeENS() {
    _decodeENS = _async_to_generator(regeneratorRuntime.mark(function _callee(ensDomain) {
        var RPC_URL, provider, address;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    RPC_URL = getRpcUrlsForChain(ETHEREUM_MAINNET_ID)[0];
                    provider = new ethers.providers.StaticJsonRpcProvider(RPC_URL);
                    _ctx.next = 5;
                    return provider.resolveName(ensDomain);
                case 5:
                    address = _ctx.sent;
                    addUserAdddressToUrl(address);
                    return _ctx.abrupt("return", address);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Error decoding ENS domain:", _ctx.t0);
                    return _ctx.abrupt("return", null);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return _decodeENS.apply(this, arguments);
}
var addUserAdddressToUrl = function(address) {
    var currentUrl = new URL(window.location.href);
    currentUrl.pathname += "/".concat(address);
    window.history.pushState({}, "", currentUrl);
};
var TokenType = {
    RECEIPT: "receipt",
    NON_RECEIPT: "non_receipt",
    INCOME: "income"
};
function displayPrettyNumber(number) {
    var shortened = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!number) return "0.00";
    number = parseFloat(number);
    if (isNaN(number)) {
        console.log("unable to parse ".concat(number, " -- please check!"));
        return "0.00";
    }
    var formatNumberWithCommas = function(number) {
        var ref = (0,src_sliced_to_array/* default */.Z)(number.toString().split("."), 2), integerPart = ref[0], decimalPart = ref[1];
        var result = "";
        var count = 0;
        // Iterate over the integer part from the end to the beginning
        for(var i = integerPart.length - 1; i >= 0; i--){
            // Append the current digit to the result string
            result = integerPart[i] + result;
            count++;
            // After every three digits, add a comma (but not at the beginning)
            if (count % 3 === 0 && i !== 0) {
                result = "," + result;
            }
        }
        // If there is a decimal part, append it to the result with a dot
        if (decimalPart) {
            result += "." + decimalPart;
        }
        return result;
    };
    var fractionDigits = toDecimalPlaceDigits(number);
    try {
        var absNumber = Math.abs(number);
        var thresholds = [
            {
                value: 1000000000,
                symbol: "B",
                fractionDigits: shortened ? 0 : 2
            },
            {
                value: 1000000,
                symbol: "M",
                fractionDigits: shortened ? 0 : 2
            }, 
        ];
        var threshold = thresholds.find(function(th) {
            return absNumber >= th.value;
        });
        if (threshold) {
            return "".concat((number / threshold.value).toFixed(threshold.fractionDigits)).concat(threshold.symbol);
        }
        if (absNumber >= 1000 && absNumber < 1000000) {
            return formatNumberWithCommas(number.toFixed(fractionDigits));
        }
        if (absNumber > 0 && absNumber < 0.000001) {
            return "<0.000001";
        }
        return number.toFixed(fractionDigits);
    } catch (e) {
        console.log("unable to parse ".concat(number, " -- please check!"));
        return "0";
    }
}
function toDecimalPlaceDigits(input) {
    var num = Math.abs(input);
    if (num === 0) {
        return 2;
    }
    if (num >= 1) {
        return 2;
    }
    if (num >= 0.99) {
        return 3;
    }
    if (num >= 0.1) {
        return 4;
    }
    if (num >= 0.01) {
        return 5;
    }
    if (num >= 0.001) {
        return 6;
    }
    if (num >= 0.0001) {
        return 7;
    }
    if (num >= 0.00001) {
        return 8;
    }
    if (num >= 0.000001) {
        return 9;
    }
    return 3;
}
function formatUSD(amount) {
    var noDollarSign = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!amount) return "0.00";
    amount = parseFloat(amount);
    var options;
    if (Math.abs(amount) < 10000) {
        options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        };
    } else {
        options = {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        };
    }
    var formattedAmount = amount.toLocaleString("en-US", options);
    if (!noDollarSign) {
        formattedAmount = "$" + formattedAmount;
    }
    return formattedAmount;
}
var getColumnIconExited = function(columnId) {
    switch(columnId){
        case "costBasis":
            return /*#__PURE__*/ _jsx(PinFill, {});
        case "exitValue":
            return /*#__PURE__*/ _jsx(Dollar, {});
        case "marketGainPct":
            return /*#__PURE__*/ _jsx(GraphUp, {});
        case "income":
            return /*#__PURE__*/ _jsx(Cash, {});
        case "incomeApy":
            return /*#__PURE__*/ _jsx(Percent, {});
        case "impermanentLossPctExited":
            return /*#__PURE__*/ _jsx(FileDiff, {});
        case "totalEstExitValue":
            return /*#__PURE__*/ _jsx(Wallet, {});
        case "exitDate":
            return /*#__PURE__*/ _jsx(Calendar, {});
        default:
            return null;
    }
};
var getColumnIcon = function(columnId) {
    switch(columnId){
        case "investment":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(database_up/* default */.Z, {});
        case "currentValue":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_coin/* default */.Z, {});
        case "currentValueLB":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bank/* default */.Z, {});
        case "marketGainPct":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(graph_up/* GraphUp */.n, {});
        case "totalIncome":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(cash/* Cash */.C, {});
        case "incomeApy":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(percent/* Percent */.g, {});
        case "impermanentLossPct":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(file_diff/* FileDiff */.n, {});
        case "totalEstPositionValue":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(wallet_2/* Wallet */.w, {});
        case "totalCostBasis":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(pin_fill_PinFill, {});
        case "totalSupplyValue":
        case "totalDebtValue":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bank/* default */.Z, {});
        case "totalValueChange":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(graph_up/* GraphUp */.n, {});
        case "costBasisLB":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(pin_fill_PinFill, {});
        case "type":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(flag, {});
        case "currentValueLB":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(bank/* default */.Z, {});
        case "assetValueChangeLB":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(graph_up/* GraphUp */.n, {});
        case "apyLB":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(file_diff/* FileDiff */.n, {});
        case "totalLendingYield":
        case "totalDebtCost":
        case "lendingYield":
        case "debtCost":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_coin/* default */.Z, {});
        case "totalNetYield":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(plus_slash_minus/* PlusSlashMinus */.I, {});
        case "positionAge":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(clock/* default */.Z, {});
        default:
            return null;
    }
};
var getColumnValueExited = function(columnId, entry) {
    switch(columnId){
        case "costBasis":
            var ref;
            return "".concat(formatUSD((ref = entry === null || entry === void 0 ? void 0 : entry.exitedCostUsd) !== null && ref !== void 0 ? ref : 0));
        case "exitValue":
            var ref1;
            return "".concat(formatUSD((ref1 = entry === null || entry === void 0 ? void 0 : entry.exitedValueUsd) !== null && ref1 !== void 0 ? ref1 : 0));
        case "marketGainPct":
            var ref2;
            return "".concat((entry === null || entry === void 0 ? void 0 : entry.exitedNetGainPct) > 0 ? "+" : "").concat(displayPrettyNumber((ref2 = entry === null || entry === void 0 ? void 0 : entry.exitedNetGainPct) !== null && ref2 !== void 0 ? ref2 : 0), "%");
        case "incomeApy":
            var ref3;
            return "".concat(displayPrettyNumber((ref3 = entry === null || entry === void 0 ? void 0 : entry.exitedIncomeAPY) !== null && ref3 !== void 0 ? ref3 : 0), "%");
        case "impermanentLossPctExited":
            var ref4;
            return "".concat(displayPrettyNumber((ref4 = entry === null || entry === void 0 ? void 0 : entry.exitedRoiVsHodlPct) !== null && ref4 !== void 0 ? ref4 : 0), "%");
        case "totalEstExitValue":
            var ref5, ref6;
            return "".concat(formatUSD(Number((ref5 = entry === null || entry === void 0 ? void 0 : entry.exitedValueUsd) !== null && ref5 !== void 0 ? ref5 : 0) + Number((ref6 = entry === null || entry === void 0 ? void 0 : entry.exitedCollectedIncomeUsd) !== null && ref6 !== void 0 ? ref6 : 0)));
        case "exitDate":
            return entry === null || entry === void 0 ? void 0 : entry.date;
        case "type":
            return "".concat((entry === null || entry === void 0 ? void 0 : entry.isLiabilityPosition) ? "Borrow" : "Supply");
        case "costBasisLB":
            var ref7, ref8;
            return "".concat(formatUSD((entry === null || entry === void 0 ? void 0 : entry.isLiabilityPosition) ? Math.abs((ref7 = entry === null || entry === void 0 ? void 0 : entry.exitedCostUsd) !== null && ref7 !== void 0 ? ref7 : 0) : (ref8 = entry === null || entry === void 0 ? void 0 : entry.exitedCostUsd) !== null && ref8 !== void 0 ? ref8 : 0));
        case "exitValueLB":
            var ref9;
            return "".concat(formatUSD((entry === null || entry === void 0 ? void 0 : entry.isLiabilityPosition) ? Math.abs((ref9 = entry === null || entry === void 0 ? void 0 : entry.exitedValueUsd) !== null && ref9 !== void 0 ? ref9 : 0) : entry === null || entry === void 0 ? void 0 : entry.exitedValueUsd));
        case "assetValueChangeLB":
            var ref10;
            return "".concat(displayPrettyNumber((entry === null || entry === void 0 ? void 0 : entry.isLiabilityPosition) ? Math.abs((ref10 = entry === null || entry === void 0 ? void 0 : entry.exitedNetGainPct) !== null && ref10 !== void 0 ? ref10 : 0) : entry === null || entry === void 0 ? void 0 : entry.exitedNetGainPct), "%");
        case "apyLB":
            var ref11;
            return "".concat(displayPrettyNumber((entry === null || entry === void 0 ? void 0 : entry.isLiabilityPosition) ? Math.abs((ref11 = entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareAPY) !== null && ref11 !== void 0 ? ref11 : 0) : entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareAPY), "%");
        case "tokenName":
            return "".concat(entry === null || entry === void 0 ? void 0 : entry.tokenName.toUpperCase());
        case "tokenChange":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.exitedIfHeldAmountToken),
                    " ",
                    renderArrow(),
                    displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.exitedTokenAmount)
                ]
            });
        case "priceAtExit":
            return "$".concat(displayPrettyNumber(Number(entry === null || entry === void 0 ? void 0 : entry.priceUsd)));
        case "tokenChangeValue":
            return "".concat(formatUSD((Number(entry === null || entry === void 0 ? void 0 : entry.exitedTokenAmount) - Number(entry === null || entry === void 0 ? void 0 : entry.exitedIfHeldAmountToken)) * Number(entry === null || entry === void 0 ? void 0 : entry.priceUsd)));
        case "thisPositionValue":
            var ref12;
            return "".concat(formatUSD((ref12 = entry === null || entry === void 0 ? void 0 : entry.exitedValueUsd) !== null && ref12 !== void 0 ? ref12 : 0));
        case "ifHeld":
            var ref13;
            return "".concat(formatUSD((ref13 = entry === null || entry === void 0 ? void 0 : entry.exitedHodlValueUsd) !== null && ref13 !== void 0 ? ref13 : 0));
        case "roiVsHodl":
            var ref14;
            return "".concat(formatUSD((ref14 = entry === null || entry === void 0 ? void 0 : entry.exitedRoiVsHodlUsd) !== null && ref14 !== void 0 ? ref14 : 0));
        case "if100%ETH":
            var ref15;
            return "".concat(formatUSD((ref15 = entry === null || entry === void 0 ? void 0 : entry.exitedIfHeldAllAmountEthValueUsd) !== null && ref15 !== void 0 ? ref15 : 0));
        case "if100%BTC":
            var ref16;
            return "".concat(formatUSD((ref16 = entry === null || entry === void 0 ? void 0 : entry.exitedIfHeldAllAmountBtcValueUsd) !== null && ref16 !== void 0 ? ref16 : 0));
        case "collected":
            var ref17;
            return "".concat(displayPrettyNumber((ref17 = entry === null || entry === void 0 ? void 0 : entry.exitedCumulativeCollectedIncomeAmount) !== null && ref17 !== void 0 ? ref17 : 0));
        case "collectedIncome":
            var ref18;
            return "".concat(formatUSD((ref18 = entry === null || entry === void 0 ? void 0 : entry.exitedCollectedIncomeUsd) !== null && ref18 !== void 0 ? ref18 : 0));
        case "yieldUSD":
            return "".concat(formatUSD(entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareChangeUsd));
        case "apyUSD":
            return "".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareUsdAPY), "%");
        case "yieldInTokens":
            return "".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareChange));
        case "tokenAPY":
            return "".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareAPY), "%");
        case "lendingYield":
            var ref19;
            return "".concat(formatUSD((ref19 = entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareChangeUsd) !== null && ref19 !== void 0 ? ref19 : 0));
        case "debtCost":
            var ref20;
            return "".concat(formatUSD((ref20 = entry === null || entry === void 0 ? void 0 : entry.exitedPositionShareChangeUsd) !== null && ref20 !== void 0 ? ref20 : 0));
        default:
            return null;
    }
};
var getColumnValue = function(columnId, entry) {
    switch(columnId){
        case "investment":
            var ref;
            return "".concat(formatUSD((ref = entry === null || entry === void 0 ? void 0 : entry.userPrincipalCostUsd) !== null && ref !== void 0 ? ref : 0));
        case "currentValue":
            var ref1;
            return "".concat(formatUSD((ref1 = entry === null || entry === void 0 ? void 0 : entry.positionUsdValueAtBlock) !== null && ref1 !== void 0 ? ref1 : 0));
        case "marketGainPct":
            var ref2;
            return "".concat((entry === null || entry === void 0 ? void 0 : entry.netMarketGainPct) > 0 ? "+" : "").concat(displayPrettyNumber((ref2 = entry === null || entry === void 0 ? void 0 : entry.netMarketGainPct) !== null && ref2 !== void 0 ? ref2 : 0), "%");
        case "totalIncome":
            var ref3;
            return "$".concat(displayPrettyNumber((ref3 = (entry === null || entry === void 0 ? void 0 : entry.cumulativeCollectedIncomeUsd) + (entry === null || entry === void 0 ? void 0 : entry.pendingIncomeUsd)) !== null && ref3 !== void 0 ? ref3 : 0));
        case "incomeApy":
            var ref4;
            return "".concat(displayPrettyNumber((ref4 = entry === null || entry === void 0 ? void 0 : entry.incomeApyInception) !== null && ref4 !== void 0 ? ref4 : 0), "%");
        case "impermanentLossPct":
            var ref5;
            return "".concat(displayPrettyNumber((ref5 = entry === null || entry === void 0 ? void 0 : entry.roiVsHodlPct) !== null && ref5 !== void 0 ? ref5 : 0), "%");
        case "totalEstPositionValue":
            var ref6, ref7, ref8;
            return "".concat(formatUSD(Number((ref6 = entry === null || entry === void 0 ? void 0 : entry.positionUsdValueAtBlock) !== null && ref6 !== void 0 ? ref6 : 0) + Number((ref7 = entry === null || entry === void 0 ? void 0 : entry.cumulativeCollectedIncomeUsd) !== null && ref7 !== void 0 ? ref7 : 0) + Number((ref8 = entry === null || entry === void 0 ? void 0 : entry.pendingIncomeUsd) !== null && ref8 !== void 0 ? ref8 : 0)));
        case "type":
            return "".concat((entry === null || entry === void 0 ? void 0 : entry.isLiabilityPosition) ? "Borrow" : "Supply");
        case "costBasisLB":
            var ref9;
            return "".concat(formatUSD((ref9 = entry === null || entry === void 0 ? void 0 : entry.userPrincipalCostUsd) !== null && ref9 !== void 0 ? ref9 : 0));
        case "currentValueLB":
            var ref10;
            return "".concat(formatUSD((ref10 = entry === null || entry === void 0 ? void 0 : entry.positionUsdValueAtBlock) !== null && ref10 !== void 0 ? ref10 : 0));
        case "assetValueChangeLB":
            var ref11;
            return "".concat(displayPrettyNumber((ref11 = entry === null || entry === void 0 ? void 0 : entry.netMarketGainPct) !== null && ref11 !== void 0 ? ref11 : 0), "%");
        case "apyLB":
            var ref12;
            return "".concat(displayPrettyNumber((ref12 = entry === null || entry === void 0 ? void 0 : entry.positionShareAPY) !== null && ref12 !== void 0 ? ref12 : 0), "%");
        case "lendingYield":
            var ref13;
            return "".concat(formatUSD((ref13 = entry === null || entry === void 0 ? void 0 : entry.positionShareChangeUsd) !== null && ref13 !== void 0 ? ref13 : 0));
        case "debtCost":
            var ref14;
            return "".concat(formatUSD((ref14 = entry === null || entry === void 0 ? void 0 : entry.positionShareChangeUsd) !== null && ref14 !== void 0 ? ref14 : 0));
        case "tokenName":
            return "".concat(entry === null || entry === void 0 ? void 0 : entry.tokenName.toUpperCase());
        case "tokenChange":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    displayPrettyNumber(Number(entry === null || entry === void 0 ? void 0 : entry.ifHeldAmountToken)),
                    " ",
                    renderArrow(),
                    displayPrettyNumber(Number(entry === null || entry === void 0 ? void 0 : entry.tokenAmountAtBlock))
                ]
            });
        case "currentPrice":
            return "$".concat(displayPrettyNumber(Number(entry === null || entry === void 0 ? void 0 : entry.priceUsd)));
        case "tokenChangeValue":
            return "".concat(formatUSD((Number(entry === null || entry === void 0 ? void 0 : entry.tokenAmountAtBlock) - Number(entry === null || entry === void 0 ? void 0 : entry.ifHeldAmountToken)) * Number(entry === null || entry === void 0 ? void 0 : entry.priceUsd)));
        case "collectedIncome":
            var ref15;
            return "".concat(formatUSD((ref15 = entry === null || entry === void 0 ? void 0 : entry.cumulativeCollectedIncomeUsd) !== null && ref15 !== void 0 ? ref15 : 0));
        case "pendingIncome":
            var ref16;
            return "".concat(formatUSD((ref16 = entry === null || entry === void 0 ? void 0 : entry.pendingIncomeUsd) !== null && ref16 !== void 0 ? ref16 : 0));
        case "pending":
            var ref17;
            return "".concat(displayPrettyNumber((ref17 = entry === null || entry === void 0 ? void 0 : entry.pendingIncomeAmount) !== null && ref17 !== void 0 ? ref17 : 0));
        case "collected":
            var ref18;
            return "".concat(displayPrettyNumber((ref18 = entry === null || entry === void 0 ? void 0 : entry.collectedIncomeAmount) !== null && ref18 !== void 0 ? ref18 : 0));
        case "total":
            var ref19;
            return "".concat(displayPrettyNumber((ref19 = entry === null || entry === void 0 ? void 0 : entry.totalIncomeAmount) !== null && ref19 !== void 0 ? ref19 : 0));
        case "thisPositionValue":
            var ref20;
            return "".concat(formatUSD((ref20 = entry === null || entry === void 0 ? void 0 : entry.positionUsdValueAtBlock) !== null && ref20 !== void 0 ? ref20 : 0));
        case "ifHeld":
            var ref21;
            return "$".concat(displayPrettyNumber((ref21 = entry === null || entry === void 0 ? void 0 : entry.hodlValueUsd) !== null && ref21 !== void 0 ? ref21 : 0));
        case "roiVsHodl":
            var ref22;
            return "$".concat(displayPrettyNumber((ref22 = entry === null || entry === void 0 ? void 0 : entry.roiVsHodlUsd) !== null && ref22 !== void 0 ? ref22 : 0));
        case "if100%ETH":
            var ref23;
            return "$".concat(displayPrettyNumber((ref23 = entry === null || entry === void 0 ? void 0 : entry.ifHeldAllAmountEthValueUsd) !== null && ref23 !== void 0 ? ref23 : 0));
        case "if100%BTC":
            var ref24;
            return "$".concat(displayPrettyNumber((ref24 = entry === null || entry === void 0 ? void 0 : entry.ifHeldAllAmountBtcValueUsd) !== null && ref24 !== void 0 ? ref24 : 0));
        case "yieldUSD":
            return "$".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.positionShareChangeUsd));
        case "apyUSD":
            return "".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.positionShareUsdAPY), "%");
        case "yieldInTokens":
            return "".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.positionShareChange));
        case "tokenAPY":
            return "".concat(displayPrettyNumber(entry === null || entry === void 0 ? void 0 : entry.positionShareAPY), "%");
        case "positionAge":
            return "".concat(formatEntry("positionAge", entry));
        default:
            return null;
    }
};
var checkTokenAndType = function(inputString) {
    var capitalLettersRegex = /[A-Z]{2,}/g; // Match sequences of at least two capital letters
    var capitalLettersMatch = inputString.match(capitalLettersRegex);
    var hasStableKeyword = inputString.includes("STABLE");
    var hasVariableKeyword = inputString.includes("VARIABLE");
    var token = "";
    if (capitalLettersMatch) {
        token = capitalLettersMatch.join("");
    }
    var keyword = "";
    if (hasStableKeyword) {
        keyword = " (stable)";
    } else if (hasVariableKeyword) {
        keyword = " (variable)";
    }
    return token + " " + keyword;
};
var cryptoGetRandomKey = function() {
    var crypto = window.crypto || window.msCrypto;
    var array = new Uint8Array(2);
    crypto.getRandomValues(array);
    return (array[0].toString(36) + array[1].toString(36)).substring(0, 8);
};
var assemblePositionName = function(entry, isLBPosition) {
    var result = "";
    var nonReceiptTokens = entry.tokens.filter(function(tokenEntry) {
        return isLBPosition ? tokenEntry.tokenType === TokenType.RECEIPT : tokenEntry.tokenType === TokenType.NON_RECEIPT;
    });
    if (nonReceiptTokens.length > 0) {
        nonReceiptTokens.forEach(function(param, idx) {
            var tokenName = param.tokenName;
            var appendResult = idx === 0 ? tokenName.toUpperCase() : " / ".concat(tokenName.toUpperCase());
            result = result.concat(appendResult);
        });
    } else {
        return formatAddress(entry.positionIdentifier);
    }
    return result;
};
var extractValidatorIndex = function(str) {
    var match = str.match(/validatorIndex-(\d+)/);
    return match ? match[1] : null;
};
var getBeaconChainScanLink = function(txHash) {
    var validatorIndex = extractValidatorIndex(txHash);
    return "https://beaconcha.in/validator/".concat(validatorIndex);
};
var getBlockchainScanLink = function(protocolKey, txHash) {
    var blockchainScanLinks = {
        eth: "https://etherscan.io/tx/",
        bsc: "https://bscscan.com/tx/",
        solana: "https://solscan.io/tx/",
        polygon: "https://polygonscan.com/tx/",
        aurora: "https://explorer.aurora.dev/tx/",
        evmos: "https://escan.live/tx/",
        arbitrum: "https://arbiscan.io/tx/",
        optimism: "https://optimistic.etherscan.io/tx/",
        base: "https://basescan.org/tx/",
        ronin: "https://app.roninchain.com/tx/",
        cosmoshub_staking: "https://www.mintscan.io/cosmos/tx/",
        avalanche: "https://snowtrace.io/tx/",
        scroll: "https://scrollscan.com/tx/",
        zksync: "https://explorer.zksync.io/tx/",
        gnosis: "https://gnosisscan.io/tx/"
    };
    var matchingKey = Object.keys(blockchainScanLinks).find(function(key) {
        return protocolKey.includes(key);
    });
    if (matchingKey) {
        var blockchainScanLink = blockchainScanLinks[matchingKey];
        return "".concat(blockchainScanLink).concat(txHash);
    } else {
        return "Invalid protocol key!";
    }
};
var renderTooltip = function(name, exited) {
    switch(true){
        case name === "If 100% ETH":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: exited ? "Hypothetical value at the exit time if the user had purchased ETH instead of this asset. Additional deposits increase, and any exits reduce this value. This value includes the transaction fee paid to acquire this asset." : "Hypothetical value if the user had purchased ETH instead of this asset. Additional deposits buy ETH at ETH price at that time, and any exits reduce this value by the proportion of the position that is exited. This value includes the transaction fee paid to acquire this asset.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "If 100% BTC":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: exited ? " Hypothetical value at the exit time if the user had purchased BTC instead of this asset. Additional deposits increase, and any exits reduce this value. This value includes the transaction fee paid to acquire this asset." : "Hypothetical value if the user had purchased Bitcoin instead of this asset. Additional deposits buy BTC at BTC price at that time, and any exits reduce this value by the proportion of the position that is exited. This value includes the transaction fee paid to acquire this asset.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "HODL Value":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: "Hypothetical USD value if the user didn’t enter the position.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "HODL amount":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: exited ? "Hypothetical USD value at the exit time if the user didn’t enter the position" : "Original token amount at the time of entering the position",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "Current balance":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: "Current Token amount available to withdraw.",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "Exit balance":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: "Exited token amount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "Exit token price":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: "Token price at the time of exit",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "Investment":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "USD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Average USD cost of position: This reflects the average price in USD for this position. Deposits increase this average, while withdrawals decrease it based on the percentage withdrawn."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Tokens"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "The cost basis of the position in terms of tokens. Actual deposits, withdraws, and transfers will affect this number, but changes like auto-compounding, rebasing, and interest earned do not."
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "Yield":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "USD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "The USD value of the additional tokens in the position from protocol mechanisms like rebasing or auto-compounding. This is the token yield multiplied by the tokens current price."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Tokens"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                "Unrealized position token gain/loss: This measures the difference between your initial investment in position tokens and their current quantity. In rebasing scenarios, it represents the total net rebasing accrued."
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "APY":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "USD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "An APY (Annual Percentage Yield) figure calculated using the USD Invested and Yield figures in this column and extrapolating that yield to a full year."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Tokens"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                "An APY (Annual Percentage Yield) figure calculated using the tokens Invested and Yield figures in this column and extrapolating that yield to a full year."
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        case name === "Debt":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_CustomTooltip/* default */.Z, {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "USD"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "The USD value of the additional tokens in the position from protocol mechanisms like rebasing or auto-compounding. This is the token debt multiplied by the tokens current price."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "Tokens"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                "Unrealized position token gain/loss: This measures the difference between your initial investment in position tokens and their current quantity. In rebasing scenarios, it represents the total net rebasing accrued."
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(info_circle/* InfoCircle */.Z, {})
            });
        default:
            return null;
    }
};
var ONE_DAY_IN_SECONDS = 3600 * 24;
var mapOperationType = function(operation, protocolKey, positionSnapshot) {
    switch(operation.operationType){
        case "deposit":
            return isProtocolLB(protocolKey) && !isLiabilityPosition(positionSnapshot) ? "supply" : isProtocolLB(protocolKey) ? "repay" : operation.operationType;
        case "withdraw":
            return isProtocolLB(protocolKey) && !isLiabilityPosition(positionSnapshot) ? "withdraw" : isProtocolLB(protocolKey) ? "borrow" : operation.operationType;
        case "null_op":
            return "staking operation";
        case "transfer_in":
            return isProtocolLB(protocolKey) && !isLiabilityPosition(positionSnapshot) ? "transfer supply in" : "transfer in";
        case "transfer_out":
            return isProtocolLB(protocolKey) && !isLiabilityPosition(positionSnapshot) ? "transfer supply out" : "transfer out";
        default:
            return operation.operationType;
    }
};
var maybeRenderTokenAmountsAndPrices = function(operation) {
    if ([
        "withdraw",
        "deposit"
    ].includes(operation.operationType)) {
        var filtered = operation.tokens.filter(function(token) {
            return token.tokenDirection === (operation.operationType === "withdraw" ? "Output" : "Input");
        }).filter(function(token) {
            return token.tokenType === TokenType.NON_RECEIPT;
        });
        return filtered.map(function(token, idx) {
            return /*#__PURE__*/ _jsxs("div", {
                children: [
                    "Token: ",
                    token.tokenName.toUpperCase(),
                    /*#__PURE__*/ _jsx("br", {}),
                    "Amount:",
                    " ",
                    displayPrettyNumber(operation.operationType === "withdraw" ? token.amountWithdrawnChange : token.amountDepositedChange),
                    /*#__PURE__*/ _jsx("br", {}),
                    "Price: $",
                    displayPrettyNumber(token.tokenPriceUsd),
                    idx === filtered.length - 1 ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("br", {}),
                            " ",
                            /*#__PURE__*/ _jsx("br", {})
                        ]
                    })
                ]
            }, cryptoGetRandomKey());
        });
    }
    return null;
};
var columnDataExitedNonLB = [
    {
        id: "costBasis",
        numeric: true,
        disablePadding: false,
        label: "Investment"
    },
    {
        id: "exitValue",
        numeric: true,
        disablePadding: false,
        label: "Exit Value"
    },
    {
        id: "marketGainPct",
        numeric: true,
        disablePadding: false,
        label: "Market Gain"
    },
    {
        id: "totalEstExitValue",
        numeric: true,
        disablePadding: false,
        label: "Total Exit Value"
    },
    {
        id: "exitDate",
        numeric: true,
        disablePadding: false,
        label: "Exit Date"
    }, 
];
var columnDataCurrentNonLB = [
    {
        id: "investment",
        numeric: true,
        disablePadding: false,
        label: "Investment"
    },
    {
        id: "currentValue",
        numeric: true,
        disablePadding: false,
        label: "Current Value"
    },
    {
        id: "marketGainPct",
        numeric: true,
        disablePadding: false,
        label: "Market Gain"
    },
    {
        id: "totalEstPositionValue",
        numeric: true,
        disablePadding: false,
        label: "Total Position Value"
    },
    {
        id: "positionAge",
        numeric: true,
        disablePadding: false,
        label: "Position Age"
    }, 
];
var columnDataCurrentLB = [
    {
        id: "type",
        numeric: true,
        disablePadding: false,
        label: "Type"
    },
    {
        id: "costBasisLB",
        numeric: true,
        disablePadding: false,
        label: "Investment"
    },
    {
        id: "currentValueLB",
        numeric: true,
        disablePadding: false,
        label: "Current Value"
    },
    {
        id: "assetValueChangeLB",
        numeric: true,
        disablePadding: false,
        label: "Asset Value Change"
    },
    {
        id: "apyLB",
        numeric: true,
        disablePadding: false,
        label: "APY"
    },
    {
        id: "lendingYield",
        numeric: true,
        disablePadding: false,
        label: "Lending Yield"
    },
    {
        id: "debtCost",
        numeric: true,
        disablePadding: false,
        label: "Interest Expense"
    },
    {
        id: "positionAge",
        numeric: true,
        disablePadding: false,
        label: "Position Age"
    }, 
];
var columnDataExitedLB = [
    {
        id: "type",
        numeric: true,
        disablePadding: false,
        label: "Type"
    },
    {
        id: "costBasisLB",
        numeric: true,
        disablePadding: false,
        label: "Investment"
    },
    {
        id: "exitValueLB",
        numeric: true,
        disablePadding: false,
        label: "Exit Value"
    },
    {
        id: "assetValueChangeLB",
        numeric: true,
        disablePadding: false,
        label: "Asset Value Change"
    },
    {
        id: "apyLB",
        numeric: true,
        disablePadding: false,
        label: "APY"
    },
    {
        id: "lendingYield",
        numeric: true,
        disablePadding: false,
        label: "Lending Yield"
    },
    {
        id: "debtCost",
        numeric: true,
        disablePadding: false,
        label: "Interest Expense"
    }, 
];
var columnTokens = [
    {
        id: "tokenName",
        numeric: true,
        disablePadding: false,
        label: ""
    },
    {
        id: "tokenChange",
        numeric: true,
        disablePadding: false,
        label: "Token Change"
    },
    {
        id: "currentPrice",
        numeric: true,
        disablePadding: false,
        label: "Current Price"
    },
    {
        id: "tokenChangeValue",
        numeric: true,
        disablePadding: false,
        label: "Token Change Value"
    }, 
];
var columnTokensExited = [
    {
        id: "tokenName",
        numeric: true,
        disablePadding: false,
        label: ""
    },
    {
        id: "tokenChange",
        numeric: true,
        disablePadding: false,
        label: "Token Change"
    },
    {
        id: "priceAtExit",
        numeric: true,
        disablePadding: false,
        label: "Price at Exit"
    },
    {
        id: "tokenChangeValue",
        numeric: true,
        disablePadding: false,
        label: "Token Change Value"
    }, 
];
var isProtocolLB = function(protocolKey) {
    return [
        "aave",
        "compound",
        "maker",
        "morpho",
        "spark",
        "fluid",
        "moonwell"
    ].some(function(key) {
        return protocolKey.includes(key);
    });
};
var isLBProtocolWithMultipleUnderlyingTokens = function(protocolKey, tokens) {
    var trackedTokens = tokens.filter(function(token) {
        return token.tag === "tracked_underlying";
    });
    return isProtocolLB(protocolKey) && trackedTokens.length > 1;
};
var isLiabilityPosition = function(positionSnapshot) {
    return positionSnapshot.isLiabilityPosition;
};
var getChain = function(string) {
    if (string.toLowerCase().includes("etherfi")) {
        return "EtherFi";
    } else if (string.toLowerCase().includes("wsteth")) {
        return "Lido";
    } else if (string.toLowerCase().includes("eth")) {
        return "Ethereum";
    } else if (string.toLowerCase().includes("avalanche")) {
        return "Avalanche";
    } else if (string.toLowerCase().includes("polygon")) {
        return "Polygon";
    } else if (string.toLowerCase().includes("optimism")) {
        return "Optimism";
    } else if (string.toLowerCase().includes("arbitrum")) {
        return "Arbitrum";
    } else if (string.toLowerCase().includes("base")) {
        return "Base";
    } else if (string.toLowerCase().includes("evmos")) {
        return "Evmos";
    } else if (string.toLowerCase().includes("bsc")) {
        return "Binance Smart Chain";
    } else if (string.toLowerCase().includes("solana")) {
        return "Solana";
    } else if (string.toLowerCase().includes("ronin")) {
        return "Ronin";
    } else if (string.toLowerCase().includes("cosmos")) {
        return "Cosmos";
    } else if (string.toLowerCase().includes("gnosis")) {
        return "Gnosis";
    } else if (string.toLowerCase().includes("scroll")) {
        return "Scroll";
    } else if (string.toLowerCase().includes("zksync")) {
        return "Zksync";
    }
};
var filterAndRemoveDuplicates = function(data) {
    var entriesByPositionId = new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var positionId = entry.positionIdentifier;
            var entryTimestamp = entry.timestamp;
            // Check if current entry's timestamp is more recent than the one stored in the map
            if (!entriesByPositionId.has(positionId) || entryTimestamp > entriesByPositionId.get(positionId).timestamp) {
                entriesByPositionId.set(positionId, (0,_object_spread/* default */.Z)({}, entry));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Convert the map values to an array to return
    return Array.from(entriesByPositionId.values());
};
var useWindowSize = function() {
    var ref = (0,react.useState)([
        0,
        0
    ]), size = ref[0], setSize = ref[1];
    (0,react.useLayoutEffect)(function() {
        var updateSize = function updateSize() {
            setSize([
                window.innerWidth,
                window.innerHeight
            ]);
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return function() {
            return window.removeEventListener("resize", updateSize);
        };
    }, []);
    return size;
};
var IsMobileDevice = function() {
    var windowSize = useWindowSize();
    var width = windowSize[0];
    return width < 768 && width !== 0;
};
var getBorrowedOrSuppliedPositionInfo = function(data, shouldReturnLiabilityPosition) {
    return data && data.map(function(entry) {
        return entry.dayData.filter(function(dayEntry) {
            return dayEntry.isLiabilityPosition === shouldReturnLiabilityPosition;
        }).map(function(filteredEntry) {
            if (shouldReturnLiabilityPosition) {
                return shouldReturnNegatedValues(filteredEntry);
            }
            return filteredEntry;
        });
    }).flat();
};
var extractKeysWithCapitalLetters = function(dataArray) {
    var capitalLetterRegex = /[A-Z]/;
    var extractedKeys = dataArray.reduce(function(keys, item) {
        Object.keys(item).forEach(function(key) {
            if (capitalLetterRegex.test(key)) {
                keys.add(key);
            }
        });
        return keys;
    }, new Set());
    return Array.from(extractedKeys);
};
var getParticularIncomeData = function(data, calculateIncomeFn) {
    var aggregatedIncomeData = {};
    data.forEach(function(dayDataEntry) {
        var tokens = dayDataEntry.tokens;
        tokens.forEach(function(token) {
            constructIncomeObject(token, calculateIncomeFn, aggregatedIncomeData, dayDataEntry);
        });
    });
    // Get all unique token names from tokens
    var allTokenNames = data.flatMap(function(dayDataEntry) {
        return dayDataEntry.tokens.filter(function(token) {
            return token.tokenType === TokenType.INCOME;
        }).map(function(token) {
            return token.tokenName.toUpperCase();
        });
    });
    // Create an entry for tokens without collectedIncomeAmountInUSD > 0
    allTokenNames.forEach(function(tokenName) {
        if (!aggregatedIncomeData[tokenName]) {
            aggregatedIncomeData[tokenName] = {
                val: 0,
                timestamp: 0
            };
        }
    });
    var incomeData = Object.entries(aggregatedIncomeData).map(function(param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], _$data = _param[1];
        return {
            name: name,
            val: _$data.val
        };
    });
    return incomeData;
};
var getUniqueIncomeTokens = function(data) {
    var uniqueTokens = new Set();
    data.forEach(function(entry) {
        var tokens = entry.tokens;
        tokens.forEach(function(token) {
            if (token.InctokenType === TokenType.INCOME) {
                var tokenObject = {
                    id: "token".concat(token.tokenAddress, "Value"),
                    numeric: true,
                    disablePadding: false,
                    label: token.tokenName.toUpperCase(),
                    tokenAddress: token.tokenAddress
                };
                uniqueTokens.add(JSON.stringify(tokenObject));
            }
        });
    });
    return Array.from(uniqueTokens).map(function(tokenString) {
        return JSON.parse(tokenString);
    });
};
function constructIncomeObject(token, calculateIncomeFn, aggregatedIncomeData, dayDataEntry) {
    if (token.tokenType === TokenType.INCOME) {
        var tokenName = token.tokenName.toUpperCase();
        var incomeData = calculateIncomeFn(token);
        if (!aggregatedIncomeData[tokenName] || incomeData > 0 && dayDataEntry.timestamp > aggregatedIncomeData[tokenName].timestamp) {
            aggregatedIncomeData[tokenName] = {
                val: incomeData,
                timestamp: dayDataEntry.timestamp
            };
        }
    }
}
var findLatestWithdrawalOrTransferOut = function(dataset) {
    var latestEntry = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = dataset[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = entry.dayData[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var dayDataEntry = _step1.value;
                    if (dayDataEntry.withdrawalOrTransferOut && dayDataEntry.withdrawalOrTransferOut.value === true) {
                        if (!latestEntry || moment(dayDataEntry.date, "M/D/YYYY").isAfter(moment(latestEntry.date, "M/D/YYYY"))) {
                            latestEntry = dayDataEntry;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return latestEntry;
};
function getNonReceiptTokensByDate(data, isExited) {
    var result = [];
    for(var i = 0; i < data.length; i++){
        var entry = data[i];
        var lastIndexWithExited = findLastExitedIndex(data);
        var date = entry.date, tokens = entry.tokens;
        var relevantTokens = tokens;
        var tokenObject = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = relevantTokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var token = _step.value;
                var tokenName = token.tokenName, tokenAmountAtBlock = token.tokenAmountAtBlock, exitedTokenAmount = token.exitedTokenAmount;
                if (isExited && i === lastIndexWithExited && token.tokenType === TokenType.NON_RECEIPT) {
                    tokenObject[tokenName.toUpperCase()] = exitedTokenAmount;
                } else if (token.tokenType === TokenType.NON_RECEIPT) {
                    tokenObject[tokenName.toUpperCase()] = tokenAmountAtBlock;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (Object.keys(tokenObject).length > 0) {
            var entryObject = (0,_object_spread/* default */.Z)({
                date: date
            }, tokenObject);
            result.push(entryObject);
        }
    }
    return result;
}
var CustomYAxisTick = function(props) {
    var x = props.x, y = props.y, payload = props.payload;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
        transform: "translate(".concat(x - 4, ",").concat(y - 18, ")"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("text", {
            className: "font-size-12",
            x: 0,
            y: 0,
            dy: 16,
            textAnchor: "end",
            fill: "var(--color-text)",
            children: [
                "$",
                displayPrettyNumber(payload.value)
            ]
        })
    });
};
function splitSessions(data) {
    var sessions = [];
    var currentSession = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item.isNewSession) {
                if (currentSession.length > 0) {
                    sessions.push(currentSession);
                }
                currentSession = [];
            }
            currentSession.push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (currentSession.length > 0) {
        sessions.push(currentSession);
    }
    return sessions;
}
function transformData(inputData, decodedDate) {
    var output = [];
    var lastEntry = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = inputData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (entry.isNewSession) {
                lastEntry = null; // Reset lastEntry for a new session
            }
            if (entry.date === decodedDate) {
                if (entry.userProtocolPositionSnapshotOperations.length > 0) {
                    var operationType = entry.userProtocolPositionSnapshotOperations[0].operationType;
                    if (lastEntry && lastEntry.operationType === "withdraw") {
                        operationType = "WITHDRAW";
                    }
                    entry.operationType = operationType;
                    output.push(entry);
                }
            }
            lastEntry = entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
function findEntryByDate(data, decodedDate) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var session = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = session[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var entry = _step1.value;
                    var formattedDateTime = moment_default()(entry.timestamp * 1000).utc().format("YYYY-MM-DD, HH:mm:ss");
                    if (formattedDateTime === decodedDate) {
                        return session;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function findMostRecentSession(data) {
    var mostRecentSession = null;
    var mostRecentTimestamp = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var session = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = session[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var entry = _step1.value;
                    var entryTimestamp = entry.timestamp;
                    if (entryTimestamp > mostRecentTimestamp) {
                        mostRecentTimestamp = entryTimestamp;
                        mostRecentSession = session;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mostRecentSession;
}
function findMatchingEntriesWithWithdrawal(array1, array2) {
    var datesArray1 = array1.map(function(entry) {
        return entry.timestamp;
    });
    var matchingEntries = array2.filter(function(entry) {
        return datesArray1.includes(entry.timestamp);
    });
    var foundWithdrawal = false;
    var resultEntries = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matchingEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (!foundWithdrawal) {
                resultEntries.push(entry);
                if (entry.withdrawalOrTransferOut.value === true) {
                    foundWithdrawal = true;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return resultEntries;
}
function filterEntriesByDate(data, startDate, endDate) {
    var filteredEntries = data.filter(function(entry) {
        var entryDate = new Date(entry.timestamp);
        var start = new Date(startDate);
        var end = new Date(endDate);
        return entryDate >= start && entryDate <= end;
    });
    var endDateEntries = filteredEntries.filter(function(entry) {
        return entry.date === endDate;
    });
    if (endDateEntries.length > 1) {
        var hasTrueValue = endDateEntries.some(function(entry) {
            return entry.withdrawalOrTransferOut.value;
        });
        if (hasTrueValue) {
            return filteredEntries.filter(function(entry) {
                return !(entry.date === endDate && !entry.withdrawalOrTransferOut.value);
            });
        }
    }
    return filteredEntries;
}
var calculateCostBasis = function(data) {
    return Number(data.exitedCostUsd);
};
var calculateMarketGains = function(data) {
    return Number(data.exitedNetGainUsd) + Number(data.exitedCollectedIncomeUsd);
};
var calculateMarketGainsPct = function(data) {
    return Number(data.exitedNetGainPct);
};
var calculateExitValue = function(data) {
    return Number(data.exitedValueUsd);
};
var calculateRoiVsHodl = function(data) {
    return Number(data.exitedValueUsd) - Number(data.exitedHodlValueUsd);
};
var calculateRoiVsHodlPct = function(data) {
    return (Number(data.exitedValueUsd) - Number(data.exitedHodlValueUsd)) / Number(data.exitedHodlValueUsd) * 100;
};
var calculatePendingIncomeUsd = function(data) {
    return Number(data.pendingIncomeUsd);
};
var calculateCollectedIncomeUsd = function(data) {
    return Number(data.cumulativeCollectedIncomeUsd);
};
var calculateExitedCollectedIncomeUsd = function(data) {
    return Number(data.exitedCollectedIncomeUsd);
};
function findLastExitedIndex(data) {
    for(var i = data.length - 1; i >= 0; i--){
        if (data[i] && Object.keys(data[i]).length > 0) {
            return i;
        }
    }
    return -1; // Return -1 if no entry with populated 'withdrawalOrTransferOut.exited' is found
}
var processIntervalData = function(response, isExited) {
    var rawData = isExited ? response.intervalData : response.currentIntervalData;
    var processedData = rawData.reduce(function(acc, entry) {
        var existingEntryIndex = acc.findIndex(function(item) {
            return item.positionIdentifier === entry.positionIdentifier;
        });
        if (existingEntryIndex === -1) {
            acc.push(entry);
        } else if (new Date(acc[existingEntryIndex].date) < new Date(entry.date)) {
            acc[existingEntryIndex] = entry;
        }
        return acc;
    }, []);
    return processedData.sort(function(a, b) {
        return new Date(b.date) - new Date(a.date);
    });
};
var modifyAndFindMatchingPositionDataLB = function(protocolPositionData, protocolPositionIntervalData) {
    var aggregatedSnapshotData = [];
    protocolPositionData.forEach(function(entry) {
        entry.snapshotData.forEach(function(snapshot) {
            aggregatedSnapshotData.push(snapshot);
        });
    });
    var modifiedData = protocolPositionData.map(function(entry) {
        var ref, ref1, ref2;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entry), {
            snapshotData: aggregatedSnapshotData,
            dayData: (0,_to_consumable_array/* default */.Z)(protocolPositionIntervalData === null || protocolPositionIntervalData === void 0 ? void 0 : (ref = protocolPositionIntervalData.snapshotIntervalData) === null || ref === void 0 ? void 0 : ref.items),
            positionAgeSeconds: protocolPositionIntervalData === null || protocolPositionIntervalData === void 0 ? void 0 : (ref1 = protocolPositionIntervalData.snapshotIntervalData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.positionAgeSeconds
        });
    });
    return [
        modifiedData[0]
    ];
};
var modifyAndFindMatchingPositionData = function(protocolPositionData, protocolPositionIntervalData, isExited, decodedDate, isProtocolLB) {
    var ref, ref1, ref2;
    var modifiedData = ((protocolPositionData === null || protocolPositionData === void 0 ? void 0 : (ref = protocolPositionData.positions) === null || ref === void 0 ? void 0 : ref.items) || (protocolPositionData === null || protocolPositionData === void 0 ? void 0 : (ref1 = protocolPositionData.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.positions) === null || ref2 === void 0 ? void 0 : ref2.items) || []).map(function(entry) {
        var ref, ref1, ref2;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entry), {
            dayData: (0,_to_consumable_array/* default */.Z)((protocolPositionIntervalData === null || protocolPositionIntervalData === void 0 ? void 0 : (ref = protocolPositionIntervalData.snapshotIntervalData) === null || ref === void 0 ? void 0 : ref.items) || []),
            positionAgeSeconds: protocolPositionIntervalData === null || protocolPositionIntervalData === void 0 ? void 0 : (ref1 = protocolPositionIntervalData.snapshotIntervalData) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.positionAgeSeconds
        });
    });
    if (isProtocolLB) {
        return modifiedData;
    }
    var matchingPositionData = modifiedData.flat().map(function(item) {
        if (isExited) {
            var sessions = splitSessions(item.dayData);
            var filteredSnapshots = findEntryByDate(sessions, decodedDate);
            var filteredDayData = filterEntriesByDate(item.dayData, filteredSnapshots[0].timestamp, filteredSnapshots[filteredSnapshots.length - 1].timestamp);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                dayData: filteredDayData,
                userProtocolPositionSnapshots: filteredSnapshots
            });
        } else if (item.snapshotData.some(function(item) {
            return item.isFullyExitedSession === true;
        })) {
            var sessions1 = splitSessions(item.snapshotData);
            var filteredSnapshots1 = findMostRecentSession(sessions1);
            var firstSnapshotTimestampFromMostRecentSession = filteredSnapshots1[0].timestamp;
            var filteredDayData1 = item.dayData.filter(function(item) {
                return item.timestamp >= firstSnapshotTimestampFromMostRecentSession;
            });
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                dayData: filteredDayData1,
                userProtocolPositionSnapshots: filteredSnapshots1
            });
        }
        return item;
    }).filter(Boolean);
    return matchingPositionData;
};
var prettifyAndReduceIncomeData = function(value) {
    return displayPrettyNumber(value.reduce(function(accumulator, object) {
        return parseFloat(accumulator) + parseFloat(object.val);
    }, 0));
};
var yieldColumns = [
    {
        id: "yield",
        numeric: true,
        disablePadding: false,
        label: "Yield"
    },
    {
        id: "yieldUSD",
        numeric: true,
        disablePadding: false,
        label: "Yield USD"
    },
    {
        id: "apyUSD",
        numeric: true,
        disablePadding: false,
        label: "APY USD"
    },
    {
        id: "yieldInTokens",
        numeric: true,
        disablePadding: false,
        label: "Yield in tokens"
    },
    {
        id: "tokenAPY",
        numeric: true,
        disablePadding: false,
        label: "Token APY"
    }, 
];
var incomeColumns = [
    {
        id: "collectedIncome",
        numeric: true,
        disablePadding: false,
        label: "Collected income"
    },
    {
        id: "pendingIncome",
        numeric: true,
        disablePadding: false,
        label: "Pending income"
    },
    {
        id: "totalIncome",
        numeric: true,
        disablePadding: false,
        label: "Total income"
    },
    {
        id: "incomeApy",
        numeric: true,
        disablePadding: false,
        label: "Income APY"
    }, 
];
var incomeColumnsExited = [
    {
        id: "collectedIncome",
        numeric: true,
        disablePadding: false,
        label: "Collected income"
    },
    {
        id: "incomeApy",
        numeric: true,
        disablePadding: false,
        label: "Income APY"
    }, 
];
var incomeTokenColumns = [
    {
        id: "tokenName",
        numeric: true,
        disablePadding: false,
        label: ""
    },
    {
        id: "collected",
        numeric: true,
        disablePadding: false,
        label: "Collected"
    },
    {
        id: "pending",
        numeric: true,
        disablePadding: false,
        label: "Pending"
    },
    {
        id: "total",
        numeric: true,
        disablePadding: false,
        label: "Total"
    }, 
];
var incomeTokenColumnsExited = [
    {
        id: "tokenName",
        numeric: true,
        disablePadding: false,
        label: ""
    },
    {
        id: "collected",
        numeric: true,
        disablePadding: false,
        label: "Collected"
    }, 
];
var hodlColumns = [
    {
        id: "thisPositionValue",
        numeric: true,
        disablePadding: false,
        label: "This position value"
    },
    {
        id: "ifHeld",
        numeric: true,
        disablePadding: false,
        label: "If held"
    },
    {
        id: "roiVsHodl",
        numeric: true,
        disablePadding: false,
        label: "ROI vs HOLD"
    },
    {
        id: "if100%ETH",
        numeric: true,
        disablePadding: false,
        label: "If 100% ETH"
    },
    {
        id: "if100%BTC",
        numeric: true,
        disablePadding: false,
        label: "If 100% BTC"
    }, 
];
var renderColumnTokens = function(columnData, entry, isMobile, isAlternativeLayout, protocolKey) {
    var chainId = getChainId(protocolKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: isMobile ? "blog-meta" : isAlternativeLayout ? "blog-meta-tokens alternative-layout" : "blog-meta-tokens",
        children: columnData.map(function(column) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        column.label.length > 0 ? "".concat(column.label, ":") : /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenLogo, {
                            chainId: chainId,
                            address: entry.tokenAddress,
                            sizeraw: 12,
                            size: "20px"
                        }),
                        " ",
                        getColumnValue(column.id, entry)
                    ]
                })
            }, column.id + entry.tokenAddress);
        })
    });
};
var renderColumnTokensExited = function(columnData, entry, isMobile, isAlternativeLayout, protocolKey, shouldPurgeExitedTokenLogo) {
    var chainId = getChainId(protocolKey);
    var maybeRenderTokenLogo = function() {
        return shouldPurgeExitedTokenLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenLogo, {
            chainId: chainId,
            address: entry.tokenAddress,
            sizeraw: 12,
            size: "20px"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: isMobile ? "blog-meta" : isAlternativeLayout ? "blog-meta-tokens alternative-layout" : "blog-meta-tokens",
        children: columnData.map(function(column) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        column.label.length > 0 ? "".concat(column.label, ":") : maybeRenderTokenLogo(),
                        " ",
                        getColumnValueExited(column.id, entry)
                    ]
                })
            }, column.id + entry.tokenAddress);
        })
    });
};
var getAmountWithdrawnOrDepositedChange = function(token) {
    return token.amountDepositedChange === "0" && Number(token.amountWithdrawnChange) > 0 ? "+".concat(displayPrettyNumber(token.amountWithdrawnChange)) : "".concat(displayPrettyNumber(token.amountDepositedChange)) ? "-".concat(displayPrettyNumber(token.amountDepositedChange)) : "+".concat(displayPrettyNumber(token.amountWithdrawnChange));
};
var getAmountWithdrawnOrDepositedChangeNumberOnly = function(token) {
    return token.amountDepositedChange === "0" && Number(token.amountWithdrawnChange) > 0 ? Number(token.amountWithdrawnChange) : Number(token.amountDepositedChange) ? Number(token.amountDepositedChange) : Number(token.amountWithdrawnChange);
};
var formatTokenTag = function(str) {
    if (!str) return str;
    var handleCamelCase = function(camelStr) {
        var result = "";
        for(var i = 0; i < camelStr.length; i++){
            if (camelStr[i] === camelStr[i].toUpperCase() && i !== 0) {
                result += " " + camelStr[i].toLowerCase();
            } else {
                result += camelStr[i];
            }
        }
        return result;
    };
    var formattedStr = str.charAt(0).toUpperCase() + str.slice(1);
    return handleCamelCase(formattedStr);
};
var assembleStatusMessage = function(data, onClickFunction, activeTab, successfulQueriesCount, positionsLength, isExited) {
    var headBlock = data.headBlock, lastSyncedBlock = data.lastSyncedBlock;
    var classificationOfTransactionsStatus = lastSyncedBlock === headBlock ? "done" : "not done";
    var fetchedPositionsStatus = headBlock !== lastSyncedBlock ? "not done" : successfulQueriesCount === positionsLength ? "done" : "not done";
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            style: {
                alignItems: "center",
                justifyContent: "space-between"
            },
            className: "d-flex",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: "Indexing data, use update button in a moment if all the data isn't showing done."
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                flexWrap: "wrap"
                            },
                            className: "d-flex",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex",
                                children: [
                                    "Classification of transactions: (",
                                    classificationOfTransactionsStatus,
                                    ")",
                                    " ",
                                    /*#__PURE__*/ _jsxs(CustomTooltip, {
                                        content: "At the time of this query we have indexed up to block ".concat(lastSyncedBlock, " of ").concat(headBlock, " blocks"),
                                        children: [
                                            " ",
                                            /*#__PURE__*/ _jsx(InfoCircle, {
                                                fill: "var(--color-primary)",
                                                className: "info-icon"
                                            })
                                        ]
                                    }),
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: {
                                flexWrap: "wrap"
                            },
                            className: "d-flex",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "d-flex",
                                children: isExited ? "Returning all exited sessions from ".concat(successfulQueriesCount, " of ").concat(lastSyncedBlock !== headBlock ? "?" : positionsLength, " positions: (").concat(fetchedPositionsStatus, ")") : "Fetching any current positions from ".concat(successfulQueriesCount, " of ").concat(lastSyncedBlock !== headBlock ? "?" : positionsLength, " total positions: (").concat(fetchedPositionsStatus, ")")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("a", {
                    onClick: onClickFunction,
                    className: "edu-btn btn-update",
                    children: "Update"
                })
            ]
        })
    });
};
var assembleStatusMessageDetailsPage = function(data, onClickFunction) {
    var _totalPositionsStatus = data.totalPositionsStatus, totalPositionsHeadBlock = _totalPositionsStatus.headBlock, totalPositionsLastSyncedBlock = _totalPositionsStatus.lastSyncedBlock, _snapshotIndexingStatus = data.snapshotIndexingStatus, snapshotIndexingHeadBlock = _snapshotIndexingStatus.headBlock, snapshotIndexingLastSyncedBlock = _snapshotIndexingStatus.lastSyncedBlock, _dependentIndexingStatus = data.dependentIndexingStatus, dependentIndexingHeadBlock = _dependentIndexingStatus.headBlock, dependentIndexingLastSyncedBlock = _dependentIndexingStatus.lastSyncedBlock;
    var classificationOfTransactionsStatus = totalPositionsLastSyncedBlock === totalPositionsHeadBlock ? "done" : "not done";
    var indexingEachDayWithATx = snapshotIndexingLastSyncedBlock === snapshotIndexingHeadBlock ? "done" : "currently ".concat(snapshotIndexingHeadBlock - snapshotIndexingLastSyncedBlock, " blocks behind");
    var indexingDependentData = dependentIndexingHeadBlock === dependentIndexingLastSyncedBlock ? "done" : "currently ".concat(dependentIndexingHeadBlock - dependentIndexingLastSyncedBlock, " blocks behind");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                alignItems: "center",
                justifyContent: "space-between"
            },
            className: "d-flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Indexing data, use update button in a moment to return more data."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flexWrap: "wrap"
                            },
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    "Classification of transactions: (",
                                    classificationOfTransactionsStatus,
                                    ") "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flexWrap: "wrap"
                            },
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    "Indexing each day with a transaction: (",
                                    indexingEachDayWithATx,
                                    ")"
                                ]
                            })
                        }),
                        dependentIndexingHeadBlock !== 0 && dependentIndexingLastSyncedBlock !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                flexWrap: "wrap"
                            },
                            className: "d-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    "Calculating daily totals for the Income report: (",
                                    indexingDependentData,
                                    ")"
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: onClickFunction,
                    className: "edu-btn btn-update",
                    children: "Update"
                })
            ]
        })
    });
};
var flattenData = function(data) {
    var flattenObject = function(obj) {
        var _loop = function(key) {
            if (obj.hasOwnProperty(key)) {
                var propName = parentKey ? parentKey + "_" + key : key;
                if (typeof obj[key] == "object" && obj[key] !== null) {
                    if (_instanceof(obj[key], Array)) {
                        obj[key].forEach(function(item, index) {
                            flattenObject(item, "".concat(propName, "_").concat(index), res);
                        });
                    } else {
                        flattenObject(obj[key], propName, res);
                    }
                } else {
                    res[propName] = obj[key];
                }
            }
        };
        var parentKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", res = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        for(var key in obj)_loop(key);
        return res;
    };
    return data.map(function(item) {
        return flattenObject(item);
    });
};
var isVaultsProtocol = function(protocolKey) {
    return protocolKey.includes("lido") || protocolKey.includes("rocketpool_income");
};
var checkDataValidity = function(data) {
    if (data.onDemandIntervalData !== 0) {
        return false;
    }
    for(var key in data){
        if (key !== "onDemandIntervalData" && data[key] <= 0) {
            return false;
        }
    }
    return true;
};
var formatAddress = function(address) {
    var maxLength = 13;
    if (address.length >= maxLength) {
        return address.slice(0, 6) + "..." + address.slice(-6);
    }
    return address;
};
var getChainId = function(key) {
    var chainMappings = {
        eth: 1,
        polygon: 137,
        avalanche: 43114,
        arbitrum: 42161,
        bsc: 56,
        optimism: 10,
        evmos: 9001,
        solana: -8768,
        aurora: 1313161554,
        base: 8453,
        ronin: 2020,
        gnosis: 100
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(chainMappings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), chainKey = _value[0], chainId = _value[1];
            if (key.includes(chainKey)) {
                return chainId;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return 1;
};
var headersDescriptionsForActivePositions = [
    {
        Header: "Protocol",
        Description: "The protocol of the position",
        Source: "Protocol"
    },
    {
        Header: "Position ID",
        Description: "The position ID",
        Source: "positionIdentifier"
    },
    {
        Header: "Chain ID",
        Description: "The chain ID",
        Source: "ChainID"
    },
    {
        Header: "Chain ID - Name",
        Description: "The chain IDs name",
        Source: "chainIdName"
    },
    {
        Header: "User Address",
        Description: "The address of the wallet in question",
        Source: "UserAddress"
    },
    {
        Header: "Block Number",
        Description: "The block number for this summary",
        Source: "blockNumber"
    },
    {
        Header: "Timestamp",
        Description: "Data is as of this timestamp",
        Source: "timestamp"
    },
    {
        Header: "Timestamp - Human readable",
        Description: "Data is as of this timestamp",
        Source: "timestampHumanReadable"
    },
    {
        Header: "Position Age",
        Description: "Length of time position has been open",
        Source: "positionAge"
    },
    {
        Header: "Position Shares At Block",
        Description: "The number of position shares at the time of this report",
        Source: "positionSharesAtBlock"
    },
    {
        Header: "Average Open Interest USD",
        Description: "The average deposited amount in USD for the course of the position (averaged over time)",
        Source: "avgOpenInterestUsd"
    },
    {
        Header: "Collected Income USD",
        Description: "We calculate the incomeUsd for each group and multiply it by 1 minus exitRatio and we return the sum of each group's result",
        Source: "cumulativeCollectedIncomeUsd"
    },
    {
        Header: "Pending Income USD",
        Description: "The pending income for this position to be collected",
        Source: "pendingIncomeUsd"
    },
    {
        Header: "Position USD Value at Block",
        Description: "The position’s value in USD at the block",
        Source: "positionUsdValueAtBlock"
    },
    {
        Header: "Net Market Gain",
        Description: "The gain in USD terms of the position",
        Source: "netMarketGainUsd"
    },
    {
        Header: "Is Liability Position",
        Description: "Denotes whether or not this position is a debt position",
        Source: "isLiabilityPosition"
    }, 
];
var headersDescriptionsForActiveTokens = [
    {
        Header: "Protocol",
        Description: "The protocol of the position",
        Source: "Protocol"
    },
    {
        Header: "Position ID",
        Description: "The position ID",
        Source: "positionIdentifier"
    },
    {
        Header: "Chain ID",
        Description: "The chain ID",
        Source: "ChainID"
    },
    {
        Header: "Chain ID - Name",
        Description: "The chain IDs name",
        Source: "chainIdName"
    },
    {
        Header: "User Address",
        Description: "The address of the wallet in question",
        Source: "UserAddress"
    },
    {
        Header: "Block Number",
        Description: "The block number for this summary",
        Source: "blockNumber"
    },
    {
        Header: "Timestamp",
        Description: "Data is as of this timestamp",
        Source: "timestamp"
    },
    {
        Header: "Timestamp - Human readable",
        Description: "Data is as of this timestamp",
        Source: "timestampHumanReadable"
    },
    {
        Header: "Position Age",
        Description: "Length of time position has been open",
        Source: "positionAge"
    },
    {
        Header: "Token Name",
        Description: "The name of the token",
        Source: "tokenName"
    },
    {
        Header: "Token Address",
        Description: "The address of the token",
        Source: "tokenAddress"
    },
    {
        Header: "Pending Income Amount",
        Description: "Token amount of any pending income",
        Source: "pendingIncomeAmount"
    },
    {
        Header: "Collected Income Amount",
        Description: "Token amount of any collected income allocated to this session (partial exits reduce this amount)",
        Source: "collectedIncomeAmount"
    },
    {
        Header: "Total Income Amount",
        Description: "Pending + Collected = Total. Total token amount of any income allocated to this session (partial exits reduce this amount)",
        Source: "totalIncomeAmount"
    },
    {
        Header: "Track Underlying Token Amount at Block",
        Description: "Token amount at the end of the block",
        Source: "tokenAmountAtBlock"
    },
    {
        Header: "Net Basis Token Amount",
        Description: "Tracks the net amount of token added to the position",
        Source: "ifHeldAmountToken"
    },
    {
        Header: "Token Price",
        Description: "The token price at the end of the block",
        Source: "priceUsd"
    },
    {
        Header: "Token Value in USD",
        Description: "The token value in USD at the end of the block",
        Source: "tokenValueUsd"
    },
    {
        Header: "Token Tag",
        Description: "A tag with more information about the token",
        Source: "tag"
    },
    {
        Header: "Token Type",
        Description: "The token type. Currently one of NON_RECEIPT, RECEIPT, INCOME, FEE",
        Source: "tokenType"
    }, 
];
var headersDescriptionsForExitedPositions = [
    {
        Header: "Protocol",
        Description: "The protocol of the position",
        Source: "Protocol"
    },
    {
        Header: "Position ID",
        Description: "The position ID",
        Source: "positionIdentifier"
    },
    {
        Header: "Chain ID",
        Description: "The chain ID",
        Source: "ChainID"
    },
    {
        Header: "Chain ID - Name",
        Description: "The chain IDs name",
        Source: "chainIdName"
    },
    {
        Header: "User Address",
        Description: "The address of the wallet in question",
        Source: "UserAddress"
    },
    {
        Header: "Underlying Tokens",
        Description: "The underlying tokens in the position",
        Source: ""
    },
    {
        Header: "Block Number",
        Description: "The block number of the position exit",
        Source: "blockNumber"
    },
    {
        Header: "Timestamp",
        Description: "Data is as of this timestamp",
        Source: "timestamp"
    },
    {
        Header: "Timestamp - Human readable",
        Description: "Data is as of this timestamp",
        Source: "timestampHumanReadable"
    },
    {
        Header: "Position Age",
        Description: "Length of time position was open for",
        Source: "positionAge"
    },
    {
        Header: "Is Liability Position",
        Description: "Denotes whether or not this position is a debt position",
        Source: "isLiabilityPosition"
    },
    {
        Header: "Exited Cost Basis USD",
        Description: "The average cost basis of the withdrawn portion of the position",
        Source: "exitedCostUsd"
    },
    {
        Header: "Exited Hodl Value Usd",
        Description: "Hypothetical value at exit of original tokens in their original amounts",
        Source: "exitedHodlValueUsd"
    },
    {
        Header: "Exited Roi vs Hodl Usd",
        Description: "Exited Value USD minus Exited Hodl Value",
        Source: "exitedRoiVsHodlUsd"
    },
    {
        Header: "Exited Value USD",
        Description: "The value in USD of the withdrawn portion of the position at the time of exit any separately claimed income not included",
        Source: "exitedValueUsd"
    },
    {
        Header: "Exited Net Gain USD",
        Description: "The net gain or loss for the exited portion of a position",
        Source: "exitedNetGainUsd"
    },
    {
        Header: "Exited Net Gain Percentage",
        Description: "The net market gain or loss of the exited portion of the transaction",
        Source: "exitedNetGainPct"
    },
    {
        Header: "Exit Ratio",
        Description: "Value between 0 and 1 indicating the proportion of the position exited in this transaction",
        Source: "exitRatio"
    },
    {
        Header: "Exited Collected Income USD",
        Description: "The collected income in USD allocated proportionally to the exited session",
        Source: "exitedCollectedIncomeUsd"
    },
    {
        Header: "Exited Position Shares At Block",
        Description: "The position shares exited in the transaction",
        Source: "exitedPositionSharesAtBlock"
    },
    {
        Header: "Exited User Principal Shares",
        Description: "The basis number of shares exited in the transaction",
        Source: "exitedUserPrincipalShares"
    },
    {
        Header: "Exited Position Share Change",
        Description: "The difference between the base shares and the exited position shares",
        Source: "exitedPositionShareChange"
    },
    {
        Header: "Exited Position Share Change USD",
        Description: "The USD value of the Exited Position Share Change",
        Source: "exitedPositionShareChangeUsd"
    }, 
];
var headersDescriptionsForTransactions = [
    {
        Header: "Protocol",
        Description: "The protocol of the position",
        Source: "Protocol"
    },
    {
        Header: "Position Identifier",
        Description: "The identifier of the position",
        Source: "positionIdentifier"
    },
    {
        Header: "Chain ID",
        Description: "The chain ID",
        Source: "ChainID"
    },
    {
        Header: "Chain ID - Name",
        Description: "The chain IDs name",
        Source: "chainIdName"
    },
    {
        Header: "Transaction Hash",
        Description: "The transaction hash of the transaction",
        Source: "txHash"
    },
    {
        Header: "Address",
        Description: "The address of the wallet in question",
        Source: "UserAddress"
    },
    {
        Header: "Block Number",
        Description: "The block number for this summary",
        Source: "blockNumber"
    },
    {
        Header: "Timestamp",
        Description: "Data is as of this timestamp",
        Source: "timestamp"
    },
    {
        Header: "Timestamp - Human readable",
        Description: "Data is as of this timestamp",
        Source: "timestampHumanReadable"
    },
    {
        Header: "Operation Type",
        Description: "This is the operation we have identified for the transaction. Note that one transaction can have multiple operations for a position",
        Source: "operationType"
    },
    {
        Header: "Shares Amount At Block",
        Description: "The shares that we have identified of the position at the end of the block",
        Source: "positionSharesAtBlock"
    },
    {
        Header: "Asset Value USD",
        Description: "The position’s value in USD at the time",
        Source: "positionUsdValueAtBlock"
    },
    {
        Header: "Gas Fee USD",
        Description: "The gas fee paid for the transaction",
        Source: "txFeeUsd"
    },
    {
        Header: "Gas Amount",
        Description: "The gas amount that was used for the transaction",
        Source: "gasTokenAmount"
    }, 
];
var headerDescriptionsForOperationTokens = [
    {
        Header: "Protocol",
        Description: "The protocol of the position",
        Source: "Protocol"
    },
    {
        Header: "Position ID",
        Description: "The position ID",
        Source: "positionIdentifier"
    },
    {
        Header: "Transaction Hash",
        Description: "The transaction hash of the transaction",
        Source: "txHash"
    },
    {
        Header: "Address",
        Description: "The address of the wallet in question",
        Source: "UserAddress"
    },
    {
        Header: "Block Number",
        Description: "The block number for this summary",
        Source: "blockNumber"
    },
    {
        Header: "Timestamp",
        Description: "Data is as of this timestamp",
        Source: "timestamp"
    },
    {
        Header: "Timestamp - Human readable",
        Description: "Data is as of this timestamp",
        Source: "timestampHumanReadable"
    },
    {
        Header: "Token Name",
        Description: "The token name",
        Source: "tokenName"
    },
    {
        Header: "Token Raw Amount",
        Description: "The raw token amount before it is converted to a decimal number",
        Source: "tokenRawAmount"
    },
    {
        Header: "Decimals",
        Description: "The number of decimals to apply to the raw token amount to convert it",
        Source: "decimals"
    },
    {
        Header: "Total Amount Deposited",
        Description: "The total token amount deposited in this session of the position",
        Source: "totalAmountDeposited"
    },
    {
        Header: "Total Amount withdrawn",
        Description: "The total token amount withdrawn in this session of the position",
        Source: "totalAmountWithdrawn"
    },
    {
        Header: "Amount Deposited Change",
        Description: "The amount deposited in this tx",
        Source: "amountDepositedChange"
    },
    {
        Header: "Amount Withdrawn Change",
        Description: "The amount withdrawn in this tx",
        Source: "amountWithdrawnChange"
    },
    {
        Header: "Amount Income Change",
        Description: "The amount of income claimed in this tx",
        Source: "amountIncomeChange"
    },
    {
        Header: "Token Income USD",
        Description: "The USD value of the income claimed in this tx",
        Source: "tokenIncomeUsd"
    },
    {
        Header: "Token Price USD",
        Description: "The USD token price at this block",
        Source: "tokenPriceUsd"
    },
    {
        Header: "Token Price Source",
        Description: "The source the price came from",
        Source: "tokenPriceSource"
    },
    {
        Header: "Token Amount At Block",
        Description: "The amount of the token in the position after any given operation in the tx is complete",
        Source: "tokenAmountAtBlock"
    },
    {
        Header: "Net Basis Token Amount",
        Description: "The amount of this token if the original amount was held and not put in the position - deposits increase this amount and withdraws decrease it",
        Source: "ifHeldAmountToken"
    },
    {
        Header: "Net Token Amount",
        Description: "The net amount of token just based on the deposits and withdraws",
        Source: "netTokenAmount"
    },
    {
        Header: "Token Value Usd",
        Description: "The value of the token change in this tx",
        Source: "tokenValueUsd"
    },
    {
        Header: "Virtual token",
        Description: "A true or false field that is true if the token amount shown is derived and not explicitly known from the tx logs",
        Source: "isVirtualToken"
    },
    {
        Header: "Token Tag",
        Description: "A tag with more information about the token",
        Source: "tag"
    },
    {
        Header: "Token Direction",
        Description: "For example input and output - from the perspective of the protocol and not the user address",
        Source: "tokenDirection"
    },
    {
        Header: "Token Type",
        Description: "The token type. Currently one of NON_RECEIPT, RECEIPT, INCOME, FEE",
        Source: "tokenType"
    }, 
];
function transformDataForCsv(data, staticData, headersDescriptions, includeHeaders) {
    var csvRows = [];
    if (includeHeaders) {
        var headersRow = headersDescriptions.map(function(hd) {
            return hd.Header;
        });
        var descriptionsRow = headersDescriptions.map(function(hd) {
            return hd.Description;
        });
        csvRows.push(headersRow, descriptionsRow);
    }
    var dataRow = headersDescriptions.map(function(hd) {
        var value;
        if (hd.Header === "Operation Type") {
            value = data.operations ? data.operations.map(function(operation) {
                return operation.operationType;
            }).join(", ") : "";
        } else if (hd.Header === "Underlying Tokens") {
            value = data.tokens ? data.tokens.filter(function(token) {
                return token.tokenType === "non_receipt";
            }).map(function(token) {
                return token.tokenName.toUpperCase();
            }).join("-") : "";
        } else if (staticData && staticData.hasOwnProperty(hd.Source)) {
            value = staticData[hd.Source];
        } else if (data.hasOwnProperty(hd.Source)) {
            value = data[hd.Source];
        } else {
            value = "";
        }
        value = value === null ? "null" : value;
        return value.toString();
    });
    csvRows.push(dataRow);
    return csvRows;
}
var shouldReturnNegatedValues = function(item) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
        netMarketGainUsd: Number(item.netMarketGainUsd) * -1,
        positionUsdValueAtBlock: Number(item.positionUsdValueAtBlock) * -1,
        userPrincipalCostUsd: Number(item.userPrincipalCostUsd) * -1,
        netMarketGainPct: Number(item.netMarketGainPct) * -1,
        positionShareAPY: Number(item.positionShareAPY) * -1,
        positionShareChangeUsd: Number(item.positionShareChangeUsd) * -1
    });
};
var mapEntryToTableRow = function(entry, columns, isExited) {
    var row = {};
    columns.forEach(function(column) {
        row[column.id] = isExited ? getColumnValueExited(column.id, entry) : getColumnValue(column.id, entry);
    });
    return [
        row
    ];
};
var calculatePercentageDifference = function(value1, value2) {
    return (value1 - value2) / value2 * 100;
};
var fontSize16AndFontWeight600 = {
    fontSize: 16,
    fontWeight: 600
};
var prettifyProtocolKey = function(key) {
    // Split the input string into segments
    var segments = key.split("_");
    // Determine how many segments to include based on the count of underscores
    var relevantSegments = segments.length > 2 ? segments.slice(0, 2) : segments.slice(0, 1);
    // Process each segment to capitalize the first letter
    var processedSegments = relevantSegments.map(function(segment) {
        return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
    });
    // Join the relevant segments with a space for two segments, otherwise just return the single segment
    return processedSegments.join(segments.length > 2 ? " " : "");
};
var findProtocolByKey = function(obj, keyToFind) {
    if (Array.isArray(obj.keys) && obj.keys.includes(keyToFind)) {
        return obj;
    }
    if (obj.hasOwnProperty(keyToFind)) {
        return obj[keyToFind];
    }
    if (typeof obj === "object" && obj !== null) {
        for(var key in obj){
            if (!obj.hasOwnProperty(key)) continue;
            var value = obj[key];
            if (typeof value === "object" && value !== null) {
                var result = findProtocolByKey(value, keyToFind);
                if (result !== undefined) {
                    return result;
                }
            }
        }
    }
    return undefined;
};
var getChainLogo = function(protocolKey) {
    if (protocolKey.includes("eth")) {
        return "/assets/images/crypto-logos/eth_logo.svg";
    } else if (protocolKey.includes("polygon")) {
        return "/assets/images/crypto-logos/polygon_logo.svg";
    } else if (protocolKey.includes("arbitrum")) {
        return "/assets/images/crypto-logos/arbitrum_logo.svg";
    } else if (protocolKey.includes("optimism")) {
        return "/assets/images/crypto-logos/optimism_logo.svg";
    } else if (protocolKey.includes("bsc")) {
        return "/assets/images/crypto-logos/bsc_logo.svg";
    } else if (protocolKey.includes("base")) {
        return "/assets/images/crypto-logos/base_logo.svg";
    } else if (protocolKey.includes("avalanche")) {
        return "/assets/images/crypto-logos/avalanche_logo.svg";
    } else if (protocolKey.includes("solana")) {
        return "/assets/images/crypto-logos/solana_logo.svg";
    } else if (protocolKey.includes("ronin")) {
        return "/assets/images/crypto-logos/ronin_logo.svg";
    } else if (protocolKey.includes("evmos")) {
        return "/assets/images/crypto-logos/evmos_logo.svg";
    } else if (protocolKey.includes("cosmos")) {
        return "/assets/images/crypto-logos/cosmos_logo.svg";
    } else if (protocolKey.includes("gnosis")) {
        return "/assets/images/crypto-logos/gnosis.svg";
    } else if (protocolKey.includes("zksync")) {
        return "/assets/images/crypto-logos/zksync.webp";
    } else if (protocolKey.includes("scroll")) {
        return "/assets/images/crypto-logos/scroll.svg";
    }
};
var standardChartTitleStyle = {
    fontSize: 16,
    fontWeight: 600,
    color: "white",
    textAlign: "left"
};
var appendPlusOrMinus = function(value) {
    if (Number(value) > 0) {
        return "+";
    } else {
        return "-";
    }
};
var reconfigureEntries = function(entries) {
    // Helper to extract version from key
    var getVersionFromKey = function(key) {
        var match = key.match(/_v(\d+)/);
        return match ? match[1] : null;
    };
    // Helper to normalize keys
    var normalizeKey = function(key, protocolId) {
        // Check if it's a farming or income variant from the protocolId
        var isFarming = key.includes("farming");
        var isIncome = key.includes("income");
        var isveAero = key.includes("veaero");
        // Extract version
        var version = getVersionFromKey(key);
        // Get base name (including farming/income if present)
        var baseName = isveAero ? "aerodrome_veaero" : isFarming ? "sushiswap_farming" : isIncome ? "rocketpool_income" : key.split("_")[0];
        return version ? "".concat(baseName, "_v").concat(version) : baseName;
    };
    // Group entries by their normalized key
    var entryGroups = entries.reduce(function(groups, entry) {
        var normalizedKey = normalizeKey(entry.key, entry.protocolId);
        if (!groups[normalizedKey]) {
            groups[normalizedKey] = [];
        }
        groups[normalizedKey].push(entry);
        return groups;
    }, {});
    var statusPriority = {
        beta: 4,
        dev: 3,
        alpha: 2,
        "pre-alpha": 1
    };
    return Object.entries(entryGroups).flatMap(function(param) {
        var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), normalizedKey = _param[0], group = _param[1];
        // If there's only one entry in the group, keep its original format
        if (group.length === 1) {
            var entry = group[0];
            return [
                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entry), {
                    name: entry.name.includes("veAERO") ? "Aerodrome veAERO Staking" : entry.name,
                    chain: entry.chain,
                    key: entry.key
                }), 
            ];
        }
        // For multiple entries, use the simplified format
        var bestEntry = group.reduce(function(best, current) {
            var bestPriority = statusPriority[best.status] || 0;
            var currentPriority = statusPriority[current.status] || 0;
            return currentPriority > bestPriority ? current : best;
        }, group[0]);
        return [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bestEntry), {
                key: normalizedKey,
                name: bestEntry.name,
                chain: ""
            }), 
        ];
    });
};
var cleanName = function(nameWithoutVersion) {
    var chain = getChain(nameWithoutVersion);
    if (chain) {
        // Remove the chain name and any extra spaces, handle potential "v1", "v2" etc
        var withoutChain = nameWithoutVersion.replace(new RegExp(chain, "i"), "").replace(/\s+/g, " ").trim();
        // Handle version numbers if they exist
        var versionMatch = withoutChain.match(/\s*v\d+\s*/i);
        if (versionMatch) {
            var version = versionMatch[0].trim();
            var baseName = withoutChain.replace(versionMatch[0], "").trim();
            return "".concat(baseName, " ").concat(version);
        }
        return withoutChain;
    }
    return nameWithoutVersion;
};
var handleApiRequest = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(account, query, variables) {
        var queryAddress, authToken, shouldUse, response, response1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryAddress = variables === null || variables === void 0 ? void 0 : variables.userIdentifier;
                    authToken = (0,localstorage/* getLocalStorage */.$)(constants/* AUTH_TOKEN_KEY */.nd);
                    shouldUse = shouldUseAuthToken(queryAddress, account, authToken);
                    if (!shouldUse) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.prev = 4;
                    _ctx.next = 7;
                    return axios/* default.post */.Z.post("".concat("https://qa.beta.archiveprotocol.com", "/graphql"), {
                        query: (0,printer/* print */.S)(query),
                        variables: variables
                    }, {
                        headers: {
                            Authorization: "Bearer ".concat((0,localstorage/* getLocalStorage */.$)(constants/* AUTH_TOKEN_KEY */.nd))
                        }
                    });
                case 7:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](4);
                    console.error(_ctx.t0);
                    react_toastify_esm.toast.error("Something went wrong: ".concat(_ctx.t0.message));
                    return _ctx.abrupt("return", null);
                case 16:
                    _ctx.next = 34;
                    break;
                case 18:
                    _ctx.prev = 18;
                    _ctx.next = 21;
                    return axios/* default.post */.Z.post("".concat("https://qa.proxy.archiveprotocol.com", "/graphql"), {
                        query: (0,printer/* print */.S)(query),
                        variables: variables
                    });
                case 21:
                    response1 = _ctx.sent;
                    return _ctx.abrupt("return", response1.data);
                case 25:
                    _ctx.prev = 25;
                    _ctx.t1 = _ctx["catch"](18);
                    if (!(_ctx.t1.message === "Network Error")) {
                        _ctx.next = 32;
                        break;
                    }
                    react_toastify_esm.toast.warning(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "Too many requests, please buy our",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    color: "black",
                                    textDecoration: "underline"
                                },
                                href: "https://zora.co/collect/base:0xe74e84955eca6448c22a9051c2573bacb698523e/1",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "NFT"
                            }),
                            " ",
                            "to get unlimited access."
                        ]
                    }));
                    return _ctx.abrupt("return", null);
                case 32:
                    react_toastify_esm.toast.error("Something went wrong: ".concat(_ctx.t1.message));
                    return _ctx.abrupt("return", null);
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                4,
                11
            ],
            [
                18,
                25
            ]
        ]);
    }));
    return function handleApiRequest(account, query, variables) {
        return _ref.apply(this, arguments);
    };
}();
var findAndSetProtocolObject = function(protocols, setProtocolObject, setIsFetchingProtocolObject, protocolKey) {
    var protocolObject = protocols.find(function(protocol) {
        return protocol.key === protocolKey;
    });
    if (protocolObject) {
        setProtocolObject(protocolObject);
        setIsFetchingProtocolObject(false);
    } else {
        setIsFetchingProtocolObject(false);
    }
};
var fetchProtocolsAndSet = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(setIsFetchingProtocolObject, setProtocolObject, protocolKey) {
        var response, newProtocols;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios/* default.get */.Z.get("".concat("https://qa.proxy.archiveprotocol.com", "/blueprint/getProtocolKeys"));
                case 3:
                    response = _ctx.sent;
                    newProtocols = reconfigureEntries(response.data);
                    localStorage.setItem("protocols", JSON.stringify(newProtocols));
                    findAndSetProtocolObject(newProtocols, setProtocolObject, setIsFetchingProtocolObject, protocolKey);
                    _ctx.next = 13;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Failed to fetch protocols", _ctx.t0);
                    setIsFetchingProtocolObject(false);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function fetchProtocolsAndSet(setIsFetchingProtocolObject, setProtocolObject, protocolKey) {
        return _ref.apply(this, arguments);
    };
}();
var getButtonBasedOnTitle = function(title) {
    switch(title){
        case "Contact Us":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                style: {
                    background: "transparent",
                    border: "0px",
                    padding: "0px"
                },
                id: "mava-webchat-launcher",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "mb-20",
                    children: title
                })
            });
        case "Subscribe":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                style: {
                    background: "transparent",
                    border: "0px",
                    padding: "0px"
                },
                id: "block_cta",
                "data-tally-open": "wa4OoB",
                "data-tally-layout": "modal",
                "data-tally-width": "550",
                "data-tally-hide-title": "1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "mb-20",
                    children: title
                })
            });
        case "Request API Access":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                onClick: function() {
                    (0,amplitude/* logEvent */.Kz)("clicked_request_API_access_footer");
                },
                style: {
                    background: "transparent",
                    border: "0px",
                    padding: "0px",
                    whiteSpace: "nowrap"
                },
                id: "main_cta",
                "data-tally-open": "3joeEJ",
                "data-tally-layout": "modal",
                "data-tally-width": "550",
                "data-tally-hide-title": "1",
                "data-tally-auto-close": "0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "mb-20",
                    children: title
                })
            });
    }
};
var renderArrow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        style: {
            paddingLeft: 8,
            paddingRight: 8
        },
        src: "/assets/images/arrow-right.svg",
        alt: "arrow right"
    });
};
var renderOgImage = function() {
    return "https://i.imgur.com/bb1BSkQ.png";
};
var shouldUseAuthToken = function(queryAddress, account, authToken) {
    var isNotDemoWallet = (queryAddress === null || queryAddress === void 0 ? void 0 : queryAddress.toLowerCase()) !== constants/* DEMO_WALLET */.PP;
    var hasAuthToken = !!authToken;
    return isNotDemoWallet && hasAuthToken;
};
var isBlueprintNonEVM = function(blueprintKey) {
    return blueprintKey.includes("solana") || blueprintKey.includes("cosmos");
};
function formatEntry(key, entry, isExited) {
    switch(key){
        case "positionAge":
            var duration = moment_default().duration(isExited ? entry.exitedSessionLength : entry.positionAgeSeconds, "seconds");
            var days = Math.floor(duration.asDays());
            var hours = duration.hours();
            var minutes = duration.minutes();
            return "".concat(days, " days, ").concat(hours, " hours, ").concat(minutes, " minutes");
        default:
            return "";
    }
}
var needsResync = function(indexingStatus) {
    if (!indexingStatus) {
        return true;
    }
    var headBlock = indexingStatus.headBlock, lastSyncedBlock = indexingStatus.lastSyncedBlock;
    return headBlock !== lastSyncedBlock || lastSyncedBlock === -1;
};
var createResult = function(key, data, error, needsSync, requestId) {
    return {
        key: key,
        data: data,
        error: error,
        loading: false,
        needsSync: needsSync,
        requestId: requestId
    };
};
var getKeysToQuery = function(resultsWithErrors, outOfSyncDataset, keys, protocolKey) {
    var isKeyOutOfSync = function(key) {
        return outOfSyncDataset === null || outOfSyncDataset === void 0 ? void 0 : outOfSyncDataset.some(function(item) {
            return item.key === key;
        });
    };
    var isKeyWithError = function(key) {
        return resultsWithErrors === null || resultsWithErrors === void 0 ? void 0 : resultsWithErrors.some(function(item) {
            return item.key === key;
        });
    };
    if ((outOfSyncDataset === null || outOfSyncDataset === void 0 ? void 0 : outOfSyncDataset.length) === 0) {
        var initialKeys = (keys === null || keys === void 0 ? void 0 : keys.length) > 0 ? keys : [
            protocolKey
        ];
        return initialKeys.filter(function(key) {
            return !isKeyWithError(key);
        });
    }
    if ((keys === null || keys === void 0 ? void 0 : keys.length) > 0) {
        return keys.filter(function(key) {
            return isKeyOutOfSync(key);
        }).filter(function(key) {
            return !isKeyWithError(key);
        });
    }
    if (isKeyOutOfSync(protocolKey) && !isKeyWithError(protocolKey)) {
        return [
            protocolKey
        ];
    }
    return [];
};
var buildKeyToIdentifierMap = function(resultsToResolve) {
    var keyToIdentifiersMap = new Map();
    resultsToResolve.forEach(function(result) {
        var ref;
        var key = result.key, data = result.data;
        var identifiers = (data === null || data === void 0 ? void 0 : (ref = data.totalPositions) === null || ref === void 0 ? void 0 : ref.activePositions) || [];
        identifiers.forEach(function(identifier) {
            if (!keyToIdentifiersMap.has(key)) {
                keyToIdentifiersMap.set(key, new Set());
            }
            keyToIdentifiersMap.get(key).add(identifier);
        });
    });
    return keyToIdentifiersMap;
};
function getChainBlockTime(protocolKey) {
    var chain = extractChain(protocolKey);
    var blockTimes = {
        eth: 12,
        bsc: 3,
        polygon: 2,
        arbitrum: 0.25,
        avalanche: 2,
        aurora: 1,
        evmos: 2,
        cosmoshub: 6,
        solana: 0.4,
        ronin: 3,
        optimism: 2,
        base: 2
    };
    return blockTimes[chain] || null;
}
function extractChain(protocolKey) {
    var chainIdentifiers = [
        "eth",
        "bsc",
        "polygon",
        "arbitrum",
        "avalanche",
        "aurora",
        "evmos",
        "cosmoshub",
        "solana",
        "ronin",
        "optimism",
        "base", 
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = chainIdentifiers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var identifier = _step.value;
            if (protocolKey.includes(identifier)) {
                return identifier;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
var calculateTimeDifference = function(protocolKey, indexingStatus) {
    var absoluteDifference = Math.abs((indexingStatus === null || indexingStatus === void 0 ? void 0 : indexingStatus.headBlock) - (indexingStatus === null || indexingStatus === void 0 ? void 0 : indexingStatus.lastSyncedBlock));
    var blockTimeInSeconds = getChainBlockTime(protocolKey);
    if (!blockTimeInSeconds) {
        console.error("Unknown block time for protocol: ".concat(protocolKey));
        return null;
    }
    var totalSeconds = absoluteDifference * blockTimeInSeconds;
    var days = Math.floor(totalSeconds / (24 * 60 * 60));
    var hours = Math.floor(totalSeconds % (24 * 60 * 60) / (60 * 60));
    var minutes = Math.floor(totalSeconds % (60 * 60) / 60);
    return {
        days: days,
        hours: hours,
        minutes: minutes
    };
};
var getProtocolManifestValue = function(protocolKey, isDetailsPage) {
    if (!isDetailsPage) {
        return constants/* protocolManifestMap */.kz[protocolKey] || protocolKey;
    }
    // Extract base protocol (e.g., "aave_v2" from "aave_v2_polygon")
    var baseProtocol = protocolKey.split("_").slice(0, 2).join("_");
    return constants/* protocolManifestMap */.kz[baseProtocol] || protocolKey;
};
// Predefined list of protocols that we know have multiple chain implementations
var MULTICHAIN_PROTOCOLS = [
    "aave_v3",
    "aave_v2",
    "compound_v3",
    "clipper_v1",
    "ichi_v1",
    "bril_v1",
    "morpho_v1",
    "spark_v1",
    "fluid_v1",
    "uniswap_v3",
    "balancer_v2"
];
var simplifiedReconfigureEntries = function(entries) {
    // Helper to extract version from key
    var getVersionFromKey = function(key) {
        var match = key.match(/_v(\d+)/);
        return match ? match[1] : null;
    };
    // Helper to get protocol with version
    var getProtocolWithVersion = function(protocolId, version) {
        if (version) {
            return "".concat(protocolId, "_v").concat(version);
        }
        // Check if the protocolId already contains a version (like aave_v2_ethereum)
        var versionMatch = protocolId.match(/_v(\d+)/);
        return versionMatch ? protocolId.split("_").slice(0, 2).join("_") : protocolId;
    };
    // Group entries by protocol and version
    var entryGroups = entries.reduce(function(groups, entry) {
        var baseProtocol = entry.protocolId.split("_")[0];
        var version = getVersionFromKey(entry.key);
        var protocolWithVersion = getProtocolWithVersion(baseProtocol, version);
        // Handle grouping logic
        var groupKey;
        if (MULTICHAIN_PROTOCOLS.includes(protocolWithVersion)) {
            // For known multi-chain protocols with specific versions
            groupKey = protocolWithVersion;
        } else {
            // For single-chain protocols or non-multichain protocols, use the original key
            groupKey = entry.key;
        }
        if (!groups[groupKey]) {
            groups[groupKey] = [];
        }
        groups[groupKey].push(entry);
        return groups;
    }, {});
    var processedEntries = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), protocolKey = _value[0], group = _value[1];
            var baseProtocol = protocolKey.split("_")[0];
            var version = getVersionFromKey(protocolKey);
            // Generate prettified name
            var prettifiedName = void 0;
            if (protocolKey.includes("sushiswap_farming")) {
                prettifiedName = "Sushiswap Farming";
            } else if (protocolKey.includes("aerodrome_veaero")) {
                prettifiedName = "Aerodrome veAERO Staking";
            } else {
                // Capitalize first letter of protocol name
                var protocolName = baseProtocol.charAt(0).toUpperCase() + baseProtocol.slice(1);
                // Determine version string
                var versionStr = "";
                if (version) {
                    versionStr = " V".concat(version);
                } else if (group[0].name.toLowerCase().includes("v2")) {
                    versionStr = " V2";
                } else if (group[0].name.toLowerCase().includes("v3")) {
                    versionStr = " V3";
                }
                prettifiedName = "".concat(protocolName).concat(versionStr);
            }
            // Get the entry with highest status priority
            var statusPriority = {
                beta: 4,
                dev: 3,
                alpha: 2,
                "pre-alpha": 1
            };
            var bestEntry = group.reduce(function(best, current) {
                var bestPriority = statusPriority[best.status] || 0;
                var currentPriority = statusPriority[current.status] || 0;
                return currentPriority > bestPriority ? current : best;
            }, group[0]);
            processedEntries[protocolKey] = {
                prettifiedName: prettifiedName,
                status: bestEntry.status
            };
        };
        // Process each group into the final format
        for(var _iterator = Object.entries(entryGroups)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return processedEntries;
};
var getImageForProtocol = function(protocol) {
    var protocolKey = protocol.split("_")[0].toLowerCase();
    var images = [
        "aave-aave-logo.svg",
        "avalanche-avax-logo.svg",
        "balancer-bal-logo.svg",
        "clipper-logo.jpg",
        "compound-comp-logo.svg",
        "cosmoshub-atom-logo.svg",
        "ethereum-eth-logo.svg",
        "evmos.svg",
        "gamma-strategies-gamma-logo.svg",
        "retro-ichi-logo.webp",
        "lido-dao-ldo-logo.svg",
        "maker-mkr-logo.svg",
        "orca-orca-logo.svg",
        "pancakeswap-cake-logo.svg",
        "polygon-matic-logo.svg",
        "rocketpool-eth-reth-logo.svg",
        "katana-ronin-ron-logo.svg",
        "sushiswap-sushi-logo.svg",
        "uniswap-uni-logo.svg",
        "verse-logo.png",
        "morpho-logo.png",
        "aerodrome-logo.svg",
        "spark-logo.svg",
        "bril-logo.png",
        "quickswap-logo.png",
        "spacefi-logo.png",
        "trisolaris-logo.ico",
        "across-logo.png",
        "fluid-logo.svg",
        "velodrome-logo.svg",
        "moonwell-logo.png", 
    ];
    var matchingImage = images.find(function(img) {
        return img.toLowerCase().includes(protocolKey);
    });
    return matchingImage ? "/assets/supported-user-protocols/".concat(matchingImage) : null;
};


/***/ })

}]);